<template>
    <main class="carrinho">
        <div class="container px-2 px-sm-0  px-lg-3 pg-inter-carrinho">
            <div class="sombra-direita"></div>
            <div class="sombra-esquerda"></div>
            <div class="principal bg-white my-4">
                <div class="dados-cadastrais">
                    <header class="header-pagina">
                        <h3>Carrinho de compras</h3>
                    </header>
                </div>
                <div class="alert-primary p-3">
                    <!--A data desta compra não garante que
                    <span v-for="(item, index) in resumoPedido.produtosForaPrazo">
                        <strong>{{item.nomeDestinatario}}<span v-if="index != resumoPedido.produtosForaPrazo.length - 1"> / </span> </strong>
                        tenha o material <strong>{{item.nomeProduto}}</strong>
                    </span>
                    em mãos no primeiro dia de aula. Por favor, consulte os prazos de entrega em Termos e Condições do Shopping CNA. Em caso de dúvida, procure sua escola CNA.
                    <br />
                    <strong>Importante: Isso não impede a compra do seu material. ENTENDA O PRAZO DE ENTREGA. <a href="#" @click="getTermoUso()">CLIQUE AQUI</a></strong>-->
                    <strong>Em caso de dúvidas, consulte o prazo de entrega do seu material didático. <a href="#" @click="getTermoUso()">CLIQUE AQUI</a></strong>
                </div>
                <div class="row px-3 px-md-4">
                    <section class="itens-carrinho p-1 col-md-7 col-lg-8" style="max-height:35%">
                        <div class="table-responsive table-carrinho">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>ITEM</th>
                                        <th>UN.</th>
                                        <th class="text-right">VALOR ITEM</th>
                                        <th class="text-right">DESCONTO</th>
                                        <th class="text-right">VALOR TOTAL</th>
                                        <th class="text-right">RETIRAR DO CARRINHO</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in resumoPedido.collectionPessoaProduto">
                                        <td>
                                            <div class="media">
                                                <div class="thumb-carrinho">
                                                    <img class="mr-2 img-produto align-self-center" :src="item.produto.imagem" alt="imagem produto">
                                                </div>
                                                <div class="media-body">
                                                    <div class="mb-3">
                                                        <h5 class="mt-0 font-weight-bold">{{ item.escola.nomeEscola }}</h5>                                                       
                                                        <div class="descricao-produto"> {{ item.produto.nome }}</div>
                                                        <div class="nome-destinatario">{{ item.nomeDestinatario }}</div>
                                                        <div class="descricao-promocao" v-if="item.promocao">
                                                            {{ item.promocao.nome }}
                                                            (-{{ item.promocao.ehPercentual ? '' : 'R$' }}{{ formatDecimal(item.promocao.valorDesconto) }}{{ item.promocao.ehPercentual ? '%' : '' }})
                                                        </div>
                                                    </div>
                                                    <div class="form-inline w-100 ">
                                                        <div>
                                                            <button type="button" class="btn btn-raised btn-sm btn-info mr-1 btn-promocao" @click="onOpenSelecionarPromocoes(item)">
                                                                {{aceito?'PROMOÇÃO':item.promocaoSelecionado}}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                        </td>
                                        <td class="text-right align-middle ">
                                            {{ item.quantidade == null ?  1 : item.quantidade}}
                                        </td>
                                        <td class="text-right align-middle ">
                                            {{ formatPrice(item.valor) }}
                                        </td>
                                        <td class="text-right align-middle ">
                                            {{ item.valorDesconto ? formatPrice(item.valorDesconto) : '--' }}
                                        </td>
                                        <td class="text-right align-middle ">
                                            {{ formatPrice(item.valorLiquido) }}
                                        </td>
                                        <td class="text-center align-middle ">
                                            <template v-if="item.sistemaOrigemId !== 6">
                                                <button v-if="item.ordem !== maioresOrdemPorPessoa[item.nomeDestinatario]"
                                                        v-b-tooltip
                                                        title="Para remover este item, exclua primeiro os materiais dos estágios seguintes."
                                                        class="btn btn-raised btn-sm btn-dark disabled mr-1">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                                <button v-else class="btn btn-raised btn-sm btn-danger mr-1"
                                                        v-b-tooltip
                                                        title="Remover do carrinho"
                                                        @click="onOpenModalRemoveProdutoCarrinho(item)">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </template>
                                        </td>

                                    </tr>
                                </tbody>
                                <tfoot class="bg-light row-valores">

                                    <tr v-if="resumoPedido.valorTotalDesconto">
                                        <td colspan="3">TOTAL BRUTO</td>
                                        <td colspan="2" class="text-right">{{ formatPrice(resumoPedido.valorTotalBruto) }}</td>
                                    </tr>

                                    <tr v-if="resumoPedido.tipoProduto == 'MATERIALDIDATICO'">
                                        <td colspan="3">TAXA DE ENTREGA</td>
                                        <td colspan="2" class="text-right">FRETE GRÁTIS</td>
                                    </tr>

                                    <tr v-if="resumoPedido.valorTotalDesconto" class="total-desconto">
                                        <td colspan="3"><strong>DESCONTO TOTAL</strong></td>
                                        <td colspan="2" class="text-right"><strong>{{ formatPrice(resumoPedido.valorTotalDesconto) }}</strong></td>
                                    </tr>

                                    <tr v-if="resumoPedido.loteCupom && !resumoPedido.loteCupom.ocultarCupom" class="text-small">
                                        <td colspan="3">CUPOM UTILIZADO <i>{{ resumoPedido.loteCupom.codigoCupom }}</i></td>
                                        <td colspan="2" class="text-right text-danger">
                                            <template v-if="resumoPedido.loteCupom.exibirDescontoReal">-R${{ formatDecimal(resumoPedido.loteCupom.valorDescontoReal) }}</template>
                                            <template v-else>-{{ resumoPedido.loteCupom.ehPercentual ? '' : 'R$' }}{{ formatDecimal(resumoPedido.loteCupom.valorDesconto) }}{{ resumoPedido.loteCupom.ehPercentual ? '%' : '' }}</template>
                                        </td>
                                    </tr>
                                    <tr v-if="descontoGatewaySelecionado.desconto && resumoPedido.temDescontoGateway" class="text-small">
                                        <td colspan="3">Desconto Gateway <i>{{ descontoGatewaySelecionado.gatewayNome }}</i></td>
                                        <td colspan="2" class="text-right text-danger">-{{ formatDecimal(descontoGatewaySelecionado.desconto) + '%'}}</td>
                                    </tr>

                                    <tr>
                                        <th colspan="3">
                                            <label>
                                                <strong>
                                                    TOTAL LÍQUIDO
                                                    <small v-if="resumoPedido.valorTotalDesconto > 0"><br />> com desconto</small>
                                                </strong>
                                            </label>
                                        </th>
                                        <th colspan="2" class="text-right">
                                            <h3>{{ formatPrice(resumoPedido.valorTotalLiquido) }}</h3>
                                        </th>
                                    </tr>

                                    <tr v-if="model && model.taxa" class="alert alert-warning  font-weight-bold">
                                        <td colspan="3">Taxa aplicada pelo Gateway</td>
                                        <td colspan="2" class="text-right text-danger ">{{ formatPrice(model.taxa) }}</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>

                        <div class="form-group row-cupom">
                            <div class="row" v-if="resumoPedido.loteCupom && !cupomAutoAplicado">
                                <div class="col-6 col-md-4 pr-0">
                                    <label for="cupom">Cupom Utilizado</label>
                                    <input type="text" class="form-control" name="cupom" v-model="resumoPedido.loteCupom.codigoCupom" disabled readonly />
                                </div>
                                <div class="col-4 pt-4">
                                    <button type="button" class="btn btn-raised btn-danger" @click="removerCupom(resumoPedido.collectionPessoaProduto)"><span>Remover cupom</span></button>
                                </div>
                            </div>
                            <div class="row" v-else>
                                <div class="col-6 col-md-4 pr-0">
                                    <label for="cupom">Cupom</label>
                                    <input type="text" class="form-control" name="cupom" v-model="model.cupom" />
                                </div>
                                <div class="col-4 pt-4">
                                    <button type="button" class="btn btn-raised btn-success" @click="calcularValorTotal(resumoPedido.collectionPessoaProduto)"><span>Utilizar Cupom</span></button>
                                </div>
                                <div class="col-12 pt-1" v-if="cupomAutoAplicado">
                                    <small class="text-success">Cupom <strong>{{ resumoPedido.loteCupom.codigoCupom }}</strong> aplicado automaticamente. Você pode informar outro código acima.</small>
                                    <button type="button" class="btn btn-sm btn-link text-danger p-0 ml-2" @click="naoUsarCupomAutomatico(resumoPedido.collectionPessoaProduto)">Não usar este cupom</button>
                                </div>
                            </div>
                        </div>

                        <hr class="mb-0" />
                        <div v-if="transportadora && ehCnaStore && tipoProduto=='CNASTORE'">
                            <!-- transportadora e cnaStore -->
                            <div class="bg-light py-1 mb-3">
                                <div class="row">
                                    <div class="col-12">
                                        <h5 class="pt-2 mt-1 mb-0 ml-2">
                                            <span><strong>MÉTODO DE ENTREGA - TRANSPORTADORA</strong></span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="row" style="padding-left:15px;padding-right:15px;">
                                <form>
                                    <table class="table table-hover">
                                        <tbody>
                                            <tr v-for="item in transportadora">
                                                <td>{{item.nome}}</td>
                                                <td>Verificar o prazo de entrega com a transportadora</td>
                                                <td>Frete conforme política CNA</td>
                                                <td style="text-align:center;">
                                                    <label>Selecionar método de entrega</label>
                                                    <input type="radio" name="transportadoraId" v-model="model.transportadoraId" :value="item.transportadoraId" />
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td style="font-weight:bold; text-align:center;" colspan="4">Frete conforme política CNA</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </form>
                            </div>
                        </div>


                        <hr class="mb-0" />

                        <div class="bg-light py-1 mb-3">
                            <div class="row">
                                <div class="col-6">
                                    <h5 class="pt-2 mt-1 mb-0 ml-2">
                                        <span><strong>DADOS DO COMPRADOR</strong></span>

                                    </h5>
                                </div>
                                <div class="col-6">
                                    <a :href="urlPessoaCNA" target="_blank" class="btn btn-danger btn-raised btn-sm float-right mr-2 mt-1">Meus Dados</a>
                                </div>
                            </div>
                        </div>
                        <p>
                            <div v-if="user.cpF_CNPJ">
                                <span class="font-weight-bold">{{user.cpF_CNPJ.length == 11 ? "Nome: " : "Razão Social: "}}</span> {{ user.nome }}<br>
                                <span class="font-weight-bold">{{user.cpF_CNPJ.length == 11 ? "CPF: " : "CNPJ: "}}</span> {{ user.cpF_CNPJFormatado }} <br /><br />
                            </div>
                            <span class="font-weight-bold">Endereço:</span> {{ user.rua }}<br>
                            <span class="font-weight-bold">Numero:</span> {{ user.numero }} <br />
                            <span class="font-weight-bold">Complemento:</span> {{ user.complemento }}<br>
                            <span class="font-weight-bold">Bairro:</span> {{ user.bairro }}<br>
                            <span class="font-weight-bold">Cidade:</span> {{ user.cidade }}<br>
                            <span class="font-weight-bold">Estado:</span> {{ user.uf }}<br>
                            <span class="font-weight-bold">CEP:</span> {{ user.cep }}
                        </p>

                        <hr />
                    </section>
                    <div class="col-md-5 col-lg-4 px-lg-2">
                        <div class="row">
                            <div class="p-3 col-12" v-if="pessoaProdutoRemovido.length > 0">
                                <div class="formapagamento itens-carrinho">
                                    <h5 class="text-center "><strong>REINCLUIR NO CARRINHO</strong></h5>
                                    <div class="table-responsive table-carrinho">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th class="text-right"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in pessoaProdutoRemovido" style="background-color: #8ac38b">
                                                    <td>
                                                        <div class="media">
                                                            <div class="thumb-carrinho">
                                                                <img class="mr-2 img-produto align-self-center" :src="item.produto.imagem" alt="imagem produto">
                                                            </div>
                                                            <div class="media-body">
                                                                <div class="mb-3" style="color: #356635">
                                                                    <h5 class="mt-0 font-weight-bold">{{ item.escola.nomeEscola }}</h5>
                                                                    <div class="descricao-produto"> {{ item.produto.nome }}</div>
                                                                    <div class="nome-destinatario">{{ item.nomeDestinatario }}</div>
                                                                    <div class="nome-destinatario">{{ formatPrice(item.valorLiquido) }}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td class="text-center align-middle ">
                                                        <button v-if="item.ordem !== menoresOrdemPorPessoa[item.nomeDestinatario]" 
                                                                class="btn btn-raised btn-sm btn-dark mr-1 disabled"
                                                                v-b-tooltip
                                                                title="Inclua primeiro os materiais dos estágios anteriores"
                                                                >
                                                            <i class="fa fa-shopping-cart"></i>
                                                        </button>
                                                        <button v-else class="btn btn-raised btn-sm btn-success mr-1"
                                                                v-b-tooltip
                                                                title="Incluir novamente no carrinho"
                                                                @click="onReincluirProdutoCarrinho(item)">
                                                            <i class="fa fa-shopping-cart"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <section class="resumo-pagamento p-3 col-12">
                                <div v-if="resumoPedido.valorTotalLiquido > 0">
                                    <div class="formapagamento">
                                        <h5 class="text-center "><strong>FORMAS DE PAGAMENTO</strong> </h5>
                                        <div v-if="tipoProduto == 'CNASTORE'">
                                            <b-card no-body>
                                                <div class="list-group">
                                                    <template v-for="item in gatewayEscolaFormaPagamentoResult" v-if="item.gatewayAtivo && item.gatewayId == 3">
                                                        <template v-for="gatewayFormaPagamento in orderBy(item.formasPagamento, 'formaPagamentoId')">
                                                            <button type="button" class="list-group-item list-group-item-action"
                                                                    @click="setaFormaPagamento(gatewayFormaPagamento, gatewayFormaPagamento.formaPagamentoId, item.gatewayId, gatewayFormaPagamento.parcelamento)"
                                                                    v-bind:class="{ active: model.formaPagamentoId == gatewayFormaPagamento.formaPagamentoId }">
                                                                <img :src="imagemFormaPagamento(gatewayFormaPagamento.formaPagamentoId)">
                                                                {{ gatewayFormaPagamento.formaPagamentoNome }}
                                                            </button>
                                                        </template>
                                                    </template>
                                                </div>
                                            </b-card>
                                        </div>
                                        <div v-else>
                                            <!-- Não é cnastore-->
                                            <b-card no-body>
                                                <div class="list-group">
                                                    <template v-for="item in gatewayEscolaFormaPagamentoResult" v-if="item.gatewayAtivo && item.gatewayId != 3">
                                                        <template v-for="gatewayFormaPagamento in orderBy(item.formasPagamento, 'formaPagamentoId')">
                                                            <button type="button" class="list-group-item list-group-item-action"
                                                                    @click="setaFormaPagamento(gatewayFormaPagamento, gatewayFormaPagamento.formaPagamentoId, item.gatewayId, gatewayFormaPagamento.parcelamento)"
                                                                    v-bind:class="{ active: model.formaPagamentoId == gatewayFormaPagamento.formaPagamentoId }">
                                                                <img :src="imagemFormaPagamento(gatewayFormaPagamento.formaPagamentoId)">
                                                                {{ gatewayFormaPagamento.formaPagamentoNome }}
                                                            </button>
                                                        </template>
                                                    </template>
                                                </div>
                                            </b-card>
                                        </div>
                                    </div>

                                    <form ref="form-pagamento" class="mb-0">
                                        <aside class="pagamento" v-if="model.formaPagamentoId">
                                            <h5><strong>{{ model.formaPagamentoId == 2 ? 'Detalhes Cartão' : model.formaPagamentoId == 1 ? 'Detalhes Boleto' : model.formaPagamentoId == 6 && cartaosecundario == false ? 'Primeiro Cartão' : model.formaPagamentoId == 6 && cartaosecundario == true ? 'Segundo Cartão' : model.formaPagamentoId == 3 ? 'Detalhes Boleto Parcelado' :   model.formaPagamentoId == 5 ?'Detalhes Boleto Parcelado':'Detalhes Débito'}}</strong></h5>

                                            <div class="cartao-credito">
                                                <div class="media d-table w-100">
                                                    <!--<img :src="getImagemCartao(model.numeroCartao)">-->
                                                    <div class="media-body text-right d-table-cell align-middle">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="dados-cartao" v-if="model.formaPagamentoId == 2 || model.formaPagamentoId == 4 || model.formaPagamentoId == 6">
                                                <img class="bandeiracartao " v-if="!cartaosecundario" :src="imagemCartao">
                                                <img class="bandeiracartao " v-if="cartaosecundario" :src="imagemCartao2">
                                                <div class="form-group mb-0">
                                                    <label class="bmd-label-floating">Nome impresso no cartão</label>
                                                    <input type="text" class="form-control text-uppercase" v-if="!ehTravaCamposCompra && !cartaosecundario" v-model="model.NomeImpressoCartao" required>
                                                    <input type="text" class="form-control text-uppercase" v-if="!ehTravaCamposCompra && cartaosecundario" v-model="model.NomeImpressoCartao2" required>
                                                    <input type="text" class="form-control text-uppercase" v-if="ehTravaCamposCompra && cartaosecundario" v-model="model.NomeImpressoCartao2" disabled>
                                                </div>
                                                <div class="form-group mb-0">
                                                    <label class="bmd-label-floating">Numero do cartão</label>
                                                    <the-mask type="text" v-if="!ehTravaCamposCompra && !cartaosecundario" class="form-control" @change.native="getCardFlag(model.numeroCartao)" :mask="'################'" v-model="model.numeroCartao" required />
                                                    <the-mask type="text" v-if="!ehTravaCamposCompra && cartaosecundario" class="form-control" @change.native="getCardFlag(model.numeroCartao2)" :mask="'################'" v-model="model.numeroCartao2" required />
                                                    <the-mask type="text" v-if="ehTravaCamposCompra && cartaosecundario" class="form-control" :mask="'################'" v-model="model.numeroCartao2" disabled />
                                                </div>
                                                <div class="row">
                                                    <div class="form-group col-4 ">
                                                        <label for="exampleInputName2" class="bmd-label-floating">Mês</label>
                                                        <select class="form-control" v-if="!ehTravaCamposCompra && !cartaosecundario" v-model="model.mes" required>
                                                            <option value="01">01</option>
                                                            <option value="02">02</option>
                                                            <option value="03">03</option>
                                                            <option value="04">04</option>
                                                            <option value="05">05</option>
                                                            <option value="06">06</option>
                                                            <option value="07">07</option>
                                                            <option value="08">08</option>
                                                            <option value="09">09</option>
                                                            <option value="10">10</option>
                                                            <option value="11">11</option>
                                                            <option value="12">12</option>
                                                        </select>
                                                        <select class="form-control" v-if="!ehTravaCamposCompra && cartaosecundario" v-model="model.mes2" required>
                                                            <option value="01">01</option>
                                                            <option value="02">02</option>
                                                            <option value="03">03</option>
                                                            <option value="04">04</option>
                                                            <option value="05">05</option>
                                                            <option value="06">06</option>
                                                            <option value="07">07</option>
                                                            <option value="08">08</option>
                                                            <option value="09">09</option>
                                                            <option value="10">10</option>
                                                            <option value="11">11</option>
                                                            <option value="12">12</option>
                                                        </select>
                                                        <select class="form-control" v-if="ehTravaCamposCompra && cartaosecundario" v-model="model.mes2" disabled>
                                                            <option value="01">01</option>
                                                            <option value="02">02</option>
                                                            <option value="03">03</option>
                                                            <option value="04">04</option>
                                                            <option value="05">05</option>
                                                            <option value="06">06</option>
                                                            <option value="07">07</option>
                                                            <option value="08">08</option>
                                                            <option value="09">09</option>
                                                            <option value="10">10</option>
                                                            <option value="11">11</option>
                                                            <option value="12">12</option>
                                                        </select>
                                                    </div>
                                                    <div class="form-group col-4 pl-0">
                                                        <label for="exampleInputEmail2" class="bmd-label-floating">Ano</label>
                                                        <select class="form-control" v-if="!ehTravaCamposCompra && !cartaosecundario" v-model="model.ano" required>
                                                            <option v-for="ano in anosPermitidos" v-bind:value="ano.value">{{ ano.text }}</option>
                                                        </select>
                                                        <select class="form-control" v-if="!ehTravaCamposCompra && cartaosecundario" v-model="model.ano2" required>
                                                            <option v-for="ano in anosPermitidos" v-bind:value="ano.value">{{ ano.text }}</option>
                                                        </select>
                                                        <select class="form-control" v-if="ehTravaCamposCompra && cartaosecundario" v-model="model.ano2" disabled>
                                                            <option v-for="ano in anosPermitidos" v-bind:value="ano.value">{{ ano.text }}</option>
                                                        </select>
                                                    </div>
                                                    <div class="form-group col-4 pl-0 ">
                                                        <label for="exampleInputEmail2" class="bmd-label-floating">CVV</label>
                                                        <the-mask type="text" class="form-control" v-if="!ehTravaCamposCompra && !cartaosecundario" :mask="'####'" v-model="model.CVV" required />
                                                        <the-mask type="text" class="form-control" v-if="!ehTravaCamposCompra && cartaosecundario" :mask="'####'" v-model="model.CVV2" required />
                                                        <the-mask type="text" class="form-control" v-if="ehTravaCamposCompra && cartaosecundario" :mask="'####'" v-model="model.CVV2" disabled />
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="model.formaPagamentoId">
                                                <div class="row">
                                                    <div class="form-group col-12" v-if="model.formaPagamentoId == 6">
                                                        <label class="bmd-label-floating">valor a ser cobrado nesse cartão</label>
                                                        <input type="range" v-if="!cartaosecundario" style="width: inherit" min="1" v-bind:max="model.valorTotalLiquidoCNAStore" v-model="model.valorPriCartao" />
                                                        <input type="range" v-if="cartaosecundario" min="1" v-bind:value="model.valorSegCartao" disabled hidden />
                                                        <p class="bmd-label-floating" v-if="!cartaosecundario"><span>{{ formatPrice(model.valorPriCartao)}}</span></p>
                                                        <p class="bmd-label-floating" v-if="cartaosecundario"><span>{{ formatPrice(model.valorSegCartao)}}</span></p>
                                                    </div>
                                                    <div class="form-group col-12" v-if="model.formaPagamentoId == 2">
                                                        <label for="exampleInputName2" class="bmd-label-floating">Parcelas</label>
                                                        <select class="form-control" v-if="!ehTravaCamposCompra" v-model="model.parcelamento" required>
                                                            <option selected value="0">Selecione</option>
                                                            <option v-for="parcela in model.parcelamentoPermitido">{{parcela}}</option>
                                                        </select>
                                                        <select class="form-control" v-if="ehTravaCamposCompra" v-model="model.parcelamento" disabled>
                                                            <option selected value="0">Selecione</option>
                                                            <option v-for="parcela in model.parcelamentoPermitido">{{parcela}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="form-group col-12" v-if="model.formaPagamentoId == 6">
                                                        <label for="exampleInputName2" class="bmd-label-floating">Parcelas</label>
                                                        <select class="form-control" v-if="!ehTravaCamposCompra && !cartaosecundario" v-model="model.parcelamento" required>
                                                            <option selected value="0">Selecione</option>
                                                            <option v-for="parcela in model.parcelamentoPermitido">{{parcela}}</option>
                                                        </select>
                                                        <select class="form-control" v-if="!ehTravaCamposCompra && cartaosecundario" v-model="model.parcelamento2" required>
                                                            <option selected value="0">Selecione</option>
                                                            <option v-for="parcela in model.parcelamentoPermitido">{{parcela}}</option>
                                                        </select>
                                                        <select class="form-control" v-if="ehTravaCamposCompra && cartaosecundario" v-model="model.parcelamento2" required>
                                                            <option selected value="0">Selecione</option>
                                                            <option v-for="parcela in model.parcelamentoPermitido">{{parcela}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="form-group col-12" v-if="model.formaPagamentoId == 3 && ehCnaStore">
                                                        <label for="exampleInputName2" class="bmd-label-floating">Selecione a qtde. de parcelas abaixo</label>
                                                        <!--<h6>Selecione a qtde. de parcelas abaixo</h6>-->
                                                        <select class="form-control col-4" v-if="!ehTravaCamposCompra" v-model="model.parcelamento" required @change="setParcelamentoCNAStore(model.parcelamento)">
                                                            <option selected value="0">Selecione</option>
                                                            <!--<option v-for="parcela in model.parcelamentoPermitido" v-if="parcela==1 && resumoPedido.valorTotalLiquido<600">{{parcela}}</option>
                                        <option v-for="parcela in model.parcelamentoPermitido" v-if="parcela==6 && resumoPedido.valorTotalLiquido<600">{{parcela}}</option>-->
                                                            <option v-if="resumoPedido.valorTotalLiquido<600" value="1">1</option>
                                                            <option v-if="resumoPedido.valorTotalLiquido>=600" value="1">1</option>
                                                            <option v-if="resumoPedido.valorTotalLiquido>=600" value="6">6</option>
                                                        </select>

                                                        <select class="form-control col-4" v-if="ehTravaCamposCompra" v-model="model.parcelamento" disabled>
                                                            <option selected value="0">Selecione</option>
                                                            <!--<option v-for="parcela in model.parcelamentoPermitido" v-if="parcela==1 && resumoPedido.valorTotalLiquido<600">{{parcela}}</option>
                                        <option v-for="parcela in model.parcelamentoPermitido" v-if="parcela==6 && resumoPedido.valorTotalLiquido<600">{{parcela}}</option>-->
                                                            <option v-if="resumoPedido.valorTotalLiquido<600" value="1">1</option>
                                                            <option v-if="resumoPedido.valorTotalLiquido>=600" value="1">1</option>
                                                            <option v-if="resumoPedido.valorTotalLiquido>=600" value="6">6</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-8 col-md-8 total-pagamento " v-bind:class="{ boleto: model.formaPagamentoId != 2 }">
                                                        <div class="form-group col-12" v-if="model.formaPagamentoId == 5">
                                                            <!-- Formulario email e cpf se for koin -->

                                                            <label for="emailKoin" class="bmd-label-floating">Informe o E-mail:</label>
                                                            <input type="text" name="email" v-model="model.email" value="" @blur="changeDadosKoin" class="form-control" required />

                                                            <label for="cpfKoin" class="bmd-label-floating">Informe o CPF:</label>
                                                            <the-mask type="text" class="form-control" :mask="'###.###.###-##'" @blur="changeDadosKoin" required v-model="model.cpf" />

                                                            <div v-if="dadosKoin">
                                                                <label for="installment" class="bmd-label-floating">Parcelamento disponível:</label>
                                                                <select class="form-control" v-if="dadosKoin.status=='APPROVED'" required v-model="installmentKoin" @change="calcularTotalKoin">
                                                                    <option v-for="installment in dadosKoin.installmentOptions" v-bind:value="installment">{{ installment.description }}</option>
                                                                </select>
                                                                <label class="bmd-label-floating ">Vencimento primeiro boleto:<br /><span>{{retornaDataKoin(dadosKoin.installmentOptions[0].firstDueDate)}} </span></label>
                                                            </div>
                                                        </div>
                                                        <div v-if="dadosKoin">
                                                            <label class="bmd-label-floating ">Total Koin:<span> {{ formatPrice(totalKoin) }}</span></label>
                                                            <br />
                                                        </div>
                                                        <div v-if="model.formaPagamentoId != 5 && model.formaPagamentoId != 6">
                                                            <label class="bmd-label-floating">Total:<span> {{ formatPrice(resumoPedido.valorTotalLiquido) + (model.formaPagamentoId != 2 ? model.parcelamento == 1 ? ' À VISTA' : '' : '') }}</span></label>
                                                            <p class="mt-3 bmd-label-floating" v-if="model.parcelamento > 0">{{ model.parcelamento}} x <span>{{ formatPrice(resumoPedido.valorTotalLiquido / model.parcelamento)}}</span>  S/ JUROS</p>
                                                        </div>
                                                        <div v-if="model.formaPagamentoId == 6">
                                                            <label class="bmd-label-floating" v-if="!cartaosecundario">Total:<span> {{ formatPrice(model.valorPriCartao) }}</span></label>
                                                            <p class="mt-3 bmd-label-floating" v-if="model.parcelamento > 0 && !cartaosecundario">{{ model.parcelamento}} x <span>{{ formatPrice(model.valorPriCartao / model.parcelamento)}}</span>  S/ JUROS</p>
                                                            <label class="bmd-label-floating" v-if="cartaosecundario">Total:<span> {{ formatPrice(model.valorSegCartao) }}</span></label>
                                                            <p class="mt-3 bmd-label-floating" v-if="model.parcelamento2 > 0 && cartaosecundario">{{ model.parcelamento2}} x <span>{{ formatPrice(model.valorSegCartao / model.parcelamento2)}}</span>  S/ JUROS</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </aside>
                                        <div v-if="!dadosKoin && model.gatewayId!=5 && model.formaPagamentoId != 6">
                                            <button class="btn btn-danger btn-raised btn-block" type="button" @click="confirmaCompra" v-if="(!ehTravaCamposCompra)&&(model.formaPagamentoId!=5)&&(pessoaProduto.length > 0 && model.formaPagamentoId != 0 && model.gatewayId != 0)">Concluir Pedido</button>
                                            <button class="btn btn-danger btn-raised btn-block" type="button" @click="confirmaCompra" v-if="(ehTravaCamposCompra)&&(model.formaPagamentoId!=5)&&(pessoaProduto.length > 0 && model.formaPagamentoId != 0 && model.gatewayId != 0)" disabled>Concluir Pedido</button>
                                        </div>

                                        <div v-if="model.formaPagamentoId == 6">
                                            <button class="btn btn-danger btn-raised btn-block" type="button" @click="proximocartao" v-if="(!ehTravaCamposCompra)&&(model.formaPagamentoId==6)&&(pessoaProduto.length > 0 && model.formaPagamentoId != 0 && model.gatewayId != 0)&&(!cartaosecundario)">Seguir para o segundo cartão</button>
                                            <button class="btn btn-danger btn-raised btn-block" type="button" @click="proximocartao" v-if="(ehTravaCamposCompra)&&(model.formaPagamentoId==6)&&(pessoaProduto.length > 0 && model.formaPagamentoId != 0 && model.gatewayId != 0)&&(!cartaosecundario)" disabled>Seguir para o segundo cartão</button>
                                            <button class="btn btn-danger btn-raised btn-block" type="button" @click="confirmaCompra" v-if="(!ehTravaCamposCompra)&&(model.formaPagamentoId==6)&&(pessoaProduto.length > 0 && model.formaPagamentoId != 0 && model.gatewayId != 0)&&(cartaosecundario)">Concluir Pedido</button>
                                            <button class="btn btn-danger btn-raised btn-block" type="button" @click="confirmaCompra" v-if="(ehTravaCamposCompra)&&(model.formaPagamentoId==6)&&(pessoaProduto.length > 0 && model.formaPagamentoId != 0 && model.gatewayId != 0)&&(cartaosecundario)" disabled>Concluir Pedido</button>
                                        </div>

                                        <!--pre analise koin v-if="(ehTravaCamposCompra)&&(model.formaPagamentoId==5)&&(pessoaProduto.length > 0 && model.formaPagamentoId != 0 && model.gatewayId != 0)"-->
                                        <div v-if="model.gatewayId == 5 && !dadosKoin && model.formaPagamentoId == 5">
                                            <button class="btn btn-danger btn-raised btn-block" type="button" @click="verificaCompradorLogado">Pré-análise do pedido</button>
                                        </div>

                                        <div v-if="model.gatewayId == 5 && dadosKoin">
                                            <!--Concluir pedido koin-->

                                            <button type="button" class="btn text-wrap p-0 shadow mt-2 border" @click="dialogTermoUsoKoin = true">
                                                <div class="alert alert-warning mb-0" role="alert">
                                                    <i class="fa fa-exclamation-triangle"></i> CLIQUE AQUI PARA LER, ACEITAR OS TERMOS KOIN E CONCLUIR
                                                </div>

                                            </button>
                                            <button type="button" class="btn text-wrap p-0 shadow mt-2 border" @click="dialogDadosPagador=true">
                                                <div class="alert alert-warning mb-0" role="alert">
                                                    <i class="fa fa-exclamation-triangle"></i> CLIQUE AQUI PARA VERIFICAR OS DADOS DO PAGADOR
                                                </div>

                                            </button>

                                            <button class="btn btn-danger btn-raised btn-block" type="button" @click="confirmaCompra" v-if="(dadosKoin.status=='APPROVED')&&(aceiteKoin)&&(installmentKoin)&&(dadosPreenchidos)">Concluir Pedido Koin</button>
                                            <button class="btn btn-danger btn-raised btn-block" type="button" v-if="(dadosKoin.status=='APPROVED')&&(!aceiteKoin || !installmentKoin || !dadosPreenchidos)" disabled>Concluir Pedido Koin</button>
                                        </div>

                                        <button class="btn btn-danger btn-raised btn-block text-overflow" v-if="model && !model.formaPagamentoId" type="button" disabled>Escolha uma forma de Pagamento</button>
                                    </form>
                                    <div v-if="model.formaPagamentoId == 3">
                                        <h5>Regras de vencimento do boleto</h5>
                                        <ul>
                                            <li>Pedidos faturados do dia 01 até 05: Pagamento todo dia 05 do mês seguinte</li>
                                            <li>Pedidos faturados do dia 06 até 10: Pagamento todo dia 10 do mês seguinte</li>
                                            <li>Pedidos faturados do dia 11 até 15: Pagamento todo dia 15 do mês seguinte</li>
                                            <li>Pedidos faturados do dia 16 até 20: Pagamento todo dia 20 do mês seguinte</li>
                                            <li>Pedidos faturados do dia 21 até 25: Pagamento todo dia 25 do mês seguinte</li>
                                            <li>Pedidos faturados do dia 26 até 31: Pagamento todo dia 30 do mês seguinte</li>
                                        </ul>
                                    </div>
                                </div>
                                <div v-if="resumoPedido.valorTotalLiquido == 0">
                                    <button class="btn btn-danger btn-raised btn-block" type="button" @click="confirmaReservaPedido" v-if="!ehTravaCamposCompra">Reservar Pedido</button>
                                    <button class="btn btn-danger btn-raised btn-block" type="button" @click="confirmaReservaPedido" v-if="ehTravaCamposCompra" disabled>Pedido Reservado</button>
                                </div>
                            </section>
                        </div>
                    </div>





                </div>
            </div>

        </div>


        <b-modal :no-close-on-backdrop="true" size="lg" :no-close-on-esc="true" centered v-model="dialogConfirma" :hide-footer="true" title="Confirma Compra">
            <form>
                <div class="row">
                    <div class="form-group col-md-12">
                        <div class="col-xs-9">
                            <span class="font-weight-bold" v-if="(!installmentKoin && model.formaPagamentoId != 6)">
                                Tem certeza que deseja finalizar a compra no
                                {{ model.formaPagamentoId == 2 ? 'Cartão de Crédito' :  model.formaPagamentoId == 4 ? 'Cartão de Débito' : model.formaPagamentoId == 7 ? 'Pix' : 'Boleto Bancário' }}
                                {{ model.formaPagamentoId == 7 ? ' no valor ' : 'em ' + Number(model.parcelamento) + 'x' }} de
                                {{ model.parcelamento > 1 ? formatPrice(resumoPedido.valorTotalLiquido / Number(model.parcelamento)) : formatPrice(this.resumoPedido.valorTotalLiquido) }}
                            </span>
                            <span class="font-weight-bold" v-if="(installmentKoin && model.formaPagamentoId != 6)">
                                Tem certeza que deseja finalizar a compra no
                                {{ model.formaPagamentoId == 2 ? 'Cartão de Crédito' :  model.formaPagamentoId == 4 ? 'Cartão de Débito' : 'Boleto Bancário' }}
                                {{ model.formaPagamentoId == 7 ? ' no valor ' : 'em ' + Number(model.parcelamento) + 'x' }} de
                                {{ model.parcelamento > 1 ? formatPrice(this.valorParcelamentoKoin) : formatPrice(this.resumoPedido.valorTotalLiquido) }}
                            </span>
                            <span class="font-weight-bold" v-if="(cartaosecundario)">
                                Tem certeza que deseja finalizar a compra em dois cartões: <br />
                                Primeiro cartão: {{ Number(model.parcelamento) + 'x' }} de
                                {{ model.parcelamento > 1 ? formatPrice(model.valorPriCartao / Number(model.parcelamento)) : formatPrice(model.valorPriCartao) }} <br />
                                Segundo cartão: {{ Number(model.parcelamento2) + 'x' }} de
                                {{ model.parcelamento > 1 ? formatPrice(model.valorSegCartao / Number(model.parcelamento2)) : formatPrice(model.valorSegCartao) }}
                            </span>
                        </div>
                    </div>
                </div>
                <button type="button" class="btn btn-outline-secondary" @click="dialogConfirma = false">
                    <span>Voltar</span>
                </button>
                <button type="button" class="btn btn-outline-success float-right" @click="concluirPedido()">
                    <span>Confirmar Compra</span>
                </button>
            </form>
        </b-modal>

        <b-modal :no-close-on-backdrop="true" size="lg" :no-close-on-esc="true" centered v-model="dialogReservaPedido" :hide-footer="true" title="Reservar Pedido">
            <form>
                <div class="row">
                    <div class="form-group col-md-12">
                        <div class="col-xs-9">
                            <span class="font-weight-bold">
                                Tem certeza que deseja reservar seu pedido?
                            </span>
                        </div>
                    </div>
                </div>
                <button type="button" class="btn btn-outline-secondary" @click="dialogReservaPedido = false">
                    <span>Voltar</span>
                </button>
                <button type="button" class="btn btn-success float-right" @click="concluirPedido()">
                    <span>Reservar Pedido</span>
                </button>
            </form>
        </b-modal>

        <b-modal :no-close-on-backdrop="true" size="lg" :no-close-on-esc="true" centered v-model="dialogConfirmaPagamento" :hide-footer="true" @hidden="goToPedido()" title="Confirmação de Pagamento">
            <form>
                <div class="row">
                    <div class="form-group col-md-12" v-if="pedido">
                        <div v-if="exibeMensagemValorZero">
                            <div class="col-xs-9">
                                <span class="font-weight-bold">
                                    O Pedido {{ }} foi reservado com Sucesso.
                                </span>
                            </div>
                        </div>
                        <div v-else>

                            <div v-if="auxTipoProdutoId == 1 &&  pedidoTemCashback ">

                                <div class="col-xs-9" v-if="!cashBackAnual">
                                    <span class="font-weight-bold">
                                        Você está participando da promoção cashback CNA.
                                        <br />
                                        Para resgate do e utilização do cashback, sua próxima compra de material didático deverá ser realizada exclusivamente por meio da loja online Shopping CNA, impreterivelmente no período de 01/10/2022 até 30/11/2022, sob pena de perda do cashback.(Valido após o faturamento do pedido)
                                        <br />
                                    </span>
                                </div>
                                <div class="col-xs-9" v-if="cashBackAnual">
                                    <span class="font-weight-bold">
                                        Você está participando da promoção cashback CNA.
                                        <br />
                                        Para resgate do e utilização do cashback, sua próxima compra de material didático deverá ser realizada exclusivamente por meio da loja online Shopping CNA, impreterivelmente no período de 01/05/2023 até 30/06/2023, sob pena de perda do cashback.(Valido após o faturamento do pedido)
                                        <br />
                                    </span>
                                    <br />
                                    <br />
                                </div>

                            </div>

                            <div class="col-xs-9" v-if="model.formaPagamentoId == 1">
                                <span class="font-weight-bold">
                                    O Pedido {{ pedido.numeroPedido }} foi gerado com Sucesso.
                                    Para imprimir o boleto click no link abaixo. <br />
                                </span>
                                <a v-if="pedido.pedidoPagamento.urlPagamento" :href="pedido.pedidoPagamento.urlPagamento" class="btn btn-block btn-link" target="_blank">
                                    Link para impressão do Boleto</a>
                                <span v-else>O boleto está em processamento. Em instantes ele estará disponível em MEUS PEDIDOS.</span>
                                <div v-if="pedido.pedidoPagamento.linhaDigitavel" class="mt-2">
                                    <span class="font-weight-bold">Linha Digitável:</span><br />
                                    <span>{{ pedido.pedidoPagamento.linhaDigitavel }}</span><br />
                                    <button type="button" class="btn btn-outline-success my-3" @click="onCopiarLinhaDigitavel">
                                        <span>Copiar Linha Digitável</span>
                                    </button>
                                </div>
                            </div>
                            <div class="col-xs-9" v-if="model.formaPagamentoId == 2">
                                <span class="font-weight-bold">
                                    O Pedido {{ pedido.numeroPedido }} foi gerado com Sucesso.
                                </span>
                            </div>
                            <div class="col-xs-9" v-if="model.formaPagamentoId == 3">
                                <span class="font-weight-bold">
                                    O Pedido {{ pedido.numeroPedido }} foi gerado com Sucesso.
                                </span>
                            </div>
                            <div class="col-xs-9" v-if="model.formaPagamentoId == 4">
                                <span class="font-weight-bold">
                                    O Pedido {{ pedido.numeroPedido }} foi gerado com Sucesso.
                                </span>
                            </div>
                            <div class="col-xs-9" v-if="model.formaPagamentoId == 5">
                                <span class="font-weight-bold">
                                    O Pedido {{ pedido.numeroPedido }} foi gerado com Sucesso.<br />
                                    {{ pedido.pedidoPagamento ? pedido.pedidoPagamento.observacao : "" }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <button type="button" class="btn btn-success float-right" @click="goToPedido()">
                    <span>Ok</span>
                </button>
            </form>
        </b-modal>

        <b-modal :no-close-on-backdrop="true" size="lg" :no-close-on-esc="true" centered v-model="dialogAlertaAtualizarDadosPagador" :hide-footer="true" title="Atenção">
            <form>
                <div class="row">
                    <div class="form-group col-md-12">
                        <div class="col-xs-9">
                            <span class="font-weight-bold">
                                {{msgModalAlerta}}
                            </span>
                        </div>
                    </div>
                </div>
                <button type="button" class="btn btn-success float-right" @click="dialogDadosPagador = true">
                    <span>Atualizar Dados Pagador</span>
                </button>
            </form>
        </b-modal>

        <b-modal :no-close-on-backdrop="true" size="lg" :no-close-on-esc="true" centered v-model="dialogDadosPagador" :hide-footer="true" title="Confirmação de Dados Pagador">
            <form>
                <div class="row">
                    <div class="form-group col-md-12">
                        <label for="nomePagador" class="">NOME:</label>
                        <input type="text" name="nomePagador" v-model="model.nomePagador" class="form-control" required />

                        <label for="emailPagador">EMAIL:</label>
                        <input type="text" name="emailPagador" v-model="model.emailPagador" class="form-control" required disabled />

                        <label for="cpfpagador">CPF:</label>
                        <input type="text" name="cpfpagador" v-model="model.cpfpagador" v-mask="'###.###.###-##'" class="form-control" maxlength="14" required disabled />

                        <label for="telefonePagador">TELEFONE:</label>
                        <input type="text" name="telefonePagador" v-model="model.telefonePagador" class="form-control" v-mask="'(##) #####-####'" maxlength="15" required />

                        <label for="cepPagador">CEP:</label>
                        <input type="text" name="cepPagador" v-model="model.cepPagador" class="form-control" v-mask="'#####-###'" maxlength="9" required />

                        <label for="ruaPagador">RUA:</label>
                        <input type="text" name="ruaPagador" v-model="model.ruaPagador" class="form-control" required />

                        <label for="numeroPagador">NUMERO:</label>
                        <input type="text" name="numeroPagador" v-model="model.numeroPagador" class="form-control" required />

                        <label for="complementoPagador">COMPLEMENTO:</label>
                        <input type="text" name="complementoPagador" v-model="model.complementoPagador" class="form-control" required />

                        <label for="bairroPagador">BAIRRO:</label>
                        <input type="text" name="bairroPagador" v-model="model.bairroPagador" class="form-control" required />

                        <label for="cidadePagador">CIDADE:</label>
                        <input type="text" name="cidadePagador" v-model="model.cidadePagador" class="form-control" required />

                        <label for="estadoPagador">ESTADO:</label>
                        <select class="form-control" name="estadoPagador" v-model="model.estadoPagador" required>
                            <option value="AC">Acre</option>
                            <option value="AL">Alagoas</option>
                            <option value="AP">Amapá</option>
                            <option value="AM">Amazonas</option>
                            <option value="BA">Bahia</option>
                            <option value="CE">Ceara</option>
                            <option value="DF">Distrito Federal</option>
                            <option value="ES">Espírito Santo</option>
                            <option value="GO">Goiás</option>
                            <option value="MA">Maranhão</option>
                            <option value="MT">Mato Grosso</option>
                            <option value="MS">Mato Grosso do Sul</option>
                            <option value="MG">Minas Gerais</option>
                            <option value="PA">Pará</option>
                            <option value="PB">Paraíba</option>
                            <option value="PR">Paraná</option>
                            <option value="PE">Pernambuco</option>
                            <option value="PI">Piauí</option>
                            <option value="RJ">Rio de Janeiro</option>
                            <option value="RN">Rio Grande do Norte</option>
                            <option value="RS">Rio Grande do Sul</option>
                            <option value="RO">Rondônia</option>
                            <option value="RR">Roraima</option>
                            <option value="SC">Santa Catarina</option>
                            <option value="SP">São Paulo</option>
                            <option value="SE">Sergipe</option>
                            <option value="TO">Tocantins</option>
                        </select>

                        <label for="dataNascimento ">Data Nascimento:</label>
                        <input type="text" name="dataNascimento" v-model="model.dataNascimentoPagador" v-mask="'##/##/####'" class="form-control" maxlength="10" required />

                    </div>
                </div>
                <button type="button" class="btn btn-success float-right" @click="segueCompraBoletoparceladoKoin()">
                    <span>Confirmar</span>
                </button>
                <!--<button type="button" class="btn btn-outline-danger float-left" @click="dialogDadosPagador=false">
                    <span>Cancelar</span>
                </button>-->
            </form>
        </b-modal>

        <div v-if="modalMessageErrorCupom">
            <b-modal :no-close-on-backdrop="true" size="xl" :no-close-on-esc="true" centered v-model="modalMessageErrorCupom" :hide-header-close="true" :hide-footer="true" title="Aviso!">
                <div>
                    <p v-html="messagemErrorCupom">
                    </p>
                </div>

                <div style="text-align:right;">

                    <button type="button" class="btn btn-outline-success float-right" @click="closeModalErrorCupom()">
                        <span>OK</span>
                    </button>

                </div>
            </b-modal>
        </div>


        <div v-if="exibeMessageErrorPagamento && !warningPromocao.ehLivrosMesmoAluno">



            <b-modal :no-close-on-backdrop="true" size="xl" :no-close-on-esc="true" centered v-model="modalMessageErrorPromotion" :hide-footer="true" title="Aviso!">
                <div>
                    <p v-html="warningPromocao.messageErrorPromotion">

                        <!--{{warningPromocao.messageErrorPromotion}}-->

                    </p>



                </div>







                <!--<div>
                    <button type="button" class="btn btn-outline-danger float-left" @click="returnHome()">
                        <span>Voltar a tela principal</span>
                    </button>
                </div>-->
                <div style="text-align:right;">

                    <!--<input type="checkbox" value="aceito" @click="aceito = !aceito" required />
                    <span>Estou de acordo.</span>-->

                    <button type="button" class="btn btn-outline-success float-right" @click="modalMessageErrorPromotion=false">
                        <span>OK</span>
                    </button>
                    <!--<button type="button" v-if="aceito" class="btn btn-outline-success float-right" @click="modalMessageErrorPromotion=false">
                        <span>OK</span>
                    </button>

                    <button type="button" v-if="!aceito" class="btn btn-outline-success float-right" disabled>
                        <span>OK</span>
                    </button>-->
                </div>
            </b-modal>
        </div>

        <div v-if="exibeMessageErrorPagamento && warningPromocao.ehLivrosMesmoAluno">



            <b-modal :no-close-on-backdrop="true" size="xl" :no-close-on-esc="true" centered v-model="modalMessageErrorPromotion" :hide-header-close="true" :hide-footer="true" title="Aviso!">
                <div>
                    <p v-html="warningPromocao.messageErrorPromotion">

                        <!--{{warningPromocao.messageErrorPromotion}}-->

                    </p>
                </div>
                <div class="d-flex justify-content-between">

                    <div>
                        <button type="button" class="btn btn-outline-danger float-left" @click="returnHome()">
                            <span>

                                Voltar
                                a tela principal
                            </span>
                        </button>
                    </div>
                    <div class="d-flex flex-row align-items-center ml-auto">

                        <input type="checkbox" value="aceito" @click="aceito = !aceito" required class="mr-2" />

                        <span class="pr-3">Estou de acordo.</span>

                        <button type="button" v-if="aceito" class="btn btn-outline-success mb-0" @click="modalMessageErrorPromotion=false">
                            <span>OK</span>
                        </button>

                        <button type="button" v-if="!aceito" class="btn btn-outline-success mb-0" disabled>
                            <span>OK</span>
                        </button>
                    </div>
                </div>
            </b-modal>
        </div>




        <b-modal scrollable :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogPromocaoDetalhe" :hide-footer="true" title="Regulamento">

            <div class="carrosel-img" v-if="promocaoDetalhe">
                <div class="card">
                    <b-carousel id="carousel-fade"
                                style="text-shadow: 0px 0px 2px #000"
                                fade
                                controls
                                background="#ffffff"
                                img-width="1024"
                                img-height="480">
                        <b-carousel-slide v-for="item of promocaoDetalhe.collectionPromocaoEstoquePromocao"
                                          :img-src="item.promocaoEstoque.imagem"></b-carousel-slide>

                    </b-carousel>
                    <div class="card-body">
                        <div class="card-regulamento">
                            <span v-html="promocaoDetalhe.regulamento"></span>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal size="lg" scrollable :hide-header-close="true" :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="alertaPromocao" :hide-footer="true" title="Atenção!">
            <div>
                <p>Existem algumas promoções que possam ser suas.</p>
                <ul v-for="item in validarPromocao">
                    <li> <b>{{item.promocao}}</b> {{item.obs}} </li>
                </ul>
                <p>Se você se encaixa em alguma dessas condições, não conclua o pedido e entre em contato com sua escola para correção do seu cadastro.</p>
            </div>
            <button type="button" class="btn btn-outline-success float-right" @click="prosseguirCompras()">
                <span>Prosseguir</span>
            </button>
            <button type="button" class="btn btn-outline-default float-left" @click="returnHome()">
                <span>Voltar a tela principal</span>
            </button>
        </b-modal>

        <b-modal size="lg"
                 :hide-header-close="disabledTabPromocao ? true : false"
                 :no-close-on-backdrop="true"
                 :no-close-on-esc="true"
                 centered v-model="dialogSelecionarPromocao"
                 :hide-footer="true"
                 title="Promoções">
            <div>

                <b-tabs pills card horizontal class="promocao">
                    <b-tab v-for="(item, index) in resumoPedido.collectionPessoaProduto"
                           :active="index == indexTabPromotion"
                           :disabled="disabledTabPromocao ? index != indexTabPromotion : false">
                        <template v-slot:title>
                            <b-media>
                                <template v-slot:aside>
                                    <b-img width="64" :src="item.produto.imagem"></b-img>
                                </template>
                                <p class="mb-0">
                                    <strong>{{ item.escola.nomeEscola }}</strong><br />
                                    {{item.produto.nome}}<br />
                                    {{ item.nomeDestinatario }}
                                </p>
                            </b-media>

                        </template>
                        <b-card-text>
                            <p v-if="item.collectionPromocaoPrevista.length == 0">Este item não tem promoção disponível no momento.</p>
                            <p v-if="item.collectionPromocaoPrevista.length > 0">Selecione uma Promoção</p>
                            <div class="row row-cols-1 row-cols-md-3">
                                <div class="col mb-4 p-2" v-for="promocao in item.collectionPromocaoPrevista">
                                    <div class="card h-100 shadow-custom">

                                        <div class="card-body select-promocao px-2 py-3">
                                            <h5 class="text-primary card-title"><strong>{{promocao.nomePromocao}}</strong></h5>
                                            <hr />
                                            <div class="mb-2 carrosel-img">
                                                <b-carousel id="carousel-fade"
                                                            style="text-shadow: 0px 0px 2px #000;"
                                                            fade
                                                            controls
                                                            img-width="225"
                                                            img-height="205">
                                                    <b-carousel-slide v-for="item in promocao.collectionPromocaoEstoquePromocao"
                                                                      :img-src="item.promocaoEstoque.imagem"></b-carousel-slide>

                                                </b-carousel>
                                            </div>
                                            <p class="bg-light p-1">
                                                <span>
                                                    {{ promocao.descricao }}
                                                </span>
                                            </p>

                                            <h5 class="text-danger text-center w-100">
                                                Desconto de:
                                                <strong>
                                                    {{promocao.ehPercentual ? '' : 'R$'}}
                                                    {{promocao.valorDesconto}}
                                                    {{promocao.ehPercentual ? '%' : ''}}
                                                </strong>
                                            </h5>
                                            <button class="btn btn-raised btn-sm btn-link btn-block" @click="abrirDetalhesPromocao(promocao)"> Regulamento</button>

                                        </div>
                                        <div class="card-footer">
                                            <div class="toggle">
                                                <input :name="item.promocaoId" :id="'promo-' + item.pessoaProdutoId + '-' + promocao.promocaoId" type="radio" v-model="item.promocaoId" v-bind:value="promocao.promocaoId" :title="promocao.nomePromocao" />
                                                <label :for="'promo-' + item.pessoaProdutoId + '-' + promocao.promocaoId">
                                                    {{ item.promocaoId == promocao.promocaoId ? 'Selecionado' : 'Selecionar' }}
                                                </label>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </b-card-text>

                        <button v-if="disabledTabPromocao" type="button" class="btn btn-outline-danger float-left" @click="returnHome()">
                            <span>Voltar para home</span>
                        </button>
                        <button v-else type="button" class="btn btn-outline-danger float-left" @click="dialogSelecionarPromocao = false">
                            <span>Fechar</span>
                        </button>

                        <button type="button" class="btn btn-outline-success float-right" @click="nextSelectPromotion(resumoPedido.collectionPessoaProduto, index)">
                            <span>Prosseguir</span>
                        </button>

                    </b-tab>

                </b-tabs>
            </div>

        </b-modal>



        <b-modal size="lg"
                 :hide-header-close="disabledTabPromocao ? true : false"
                 :no-close-on-backdrop="true"
                 :no-close-on-esc="true"
                 centered v-model="dialogSelecionarUnicaPromocao"
                 :hide-footer="true"
                 title="Promoções">
            <div>

                <b-tabs pills card horizontal class="promocao">
                    <b-tab>
                        <template v-slot:title>
                            <b-media>
                                <template v-slot:aside>
                                    <b-img width="64" :src="promocoesPessoaProdutoSelecionado.produto.imagem"></b-img>
                                </template>
                                <p class="mb-0">
                                    <strong>{{ promocoesPessoaProdutoSelecionado.escola.nomeEscola }}</strong><br />
                                    {{promocoesPessoaProdutoSelecionado.produto.nome}}<br />
                                    {{ promocoesPessoaProdutoSelecionado.nomeDestinatario }}
                                </p>
                            </b-media>

                        </template>
                        <b-card-text>
                            <p v-if="promocoesPessoaProdutoSelecionado.collectionPromocaoPrevista.length == 0">Este item não tem promoção disponível no momento.</p>
                            <p v-if="promocoesPessoaProdutoSelecionado.collectionPromocaoPrevista.length > 0">Selecione uma Promoção</p>
                            <div class="row row-cols-1 row-cols-md-3">
                                <div class="col mb-4 p-2" v-for="promocao in promocoesPessoaProdutoSelecionado.collectionPromocaoPrevista">
                                    <div class="card h-100 shadow-custom">

                                        <div class="card-body select-promocao px-2 py-3">
                                            <h5 class="text-primary card-title"><strong>{{promocao.nomePromocao}}</strong></h5>
                                            <hr />
                                            <div class="mb-2 carrosel-img">
                                                <b-carousel id="carousel-fade"
                                                            style="text-shadow: 0px 0px 2px #000;"
                                                            fade
                                                            controls
                                                            img-width="225"
                                                            img-height="205">
                                                    <b-carousel-slide v-for="item in promocao.collectionPromocaoEstoquePromocao"
                                                                      :img-src="item.promocaoEstoque.imagem"></b-carousel-slide>

                                                </b-carousel>
                                            </div>
                                            <p class="bg-light p-1">
                                                <span>
                                                    {{ promocao.descricao }}
                                                </span>
                                            </p>

                                            <h5 class="text-danger text-center w-100">
                                                Desconto de:
                                                <strong>
                                                    {{promocao.ehPercentual ? '' : 'R$'}}
                                                    {{promocao.valorDesconto}}
                                                    {{promocao.ehPercentual ? '%' : ''}}
                                                </strong>
                                            </h5>
                                            <button class="btn btn-raised btn-sm btn-link btn-block" @click="abrirDetalhesPromocao(promocao)"> Regulamento</button>

                                        </div>
                                        <div class="card-footer">
                                            <div class="toggle">
                                                <input :name="promocoesPessoaProdutoSelecionado.promocaoId" :id="'promo-' + promocoesPessoaProdutoSelecionado.pessoaProdutoId + '-' + promocao.promocaoId" type="radio" v-model="promocoesPessoaProdutoSelecionado.promocaoId" v-bind:value="promocao.promocaoId" :title="promocao.nomePromocao" />
                                                <label :for="'promo-' + promocoesPessoaProdutoSelecionado.pessoaProdutoId + '-' + promocao.promocaoId">
                                                    {{ promocoesPessoaProdutoSelecionado.promocaoId == promocao.promocaoId ? 'Selecionado' : 'Selecionar' }}
                                                </label>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </b-card-text>

                        <button v-if="disabledTabPromocao" type="button" class="btn btn-outline-danger float-left" @click="returnHome()">
                            <span>Voltar para home</span>
                        </button>
                        <button v-else type="button" class="btn btn-outline-danger float-left" @click="dialogSelecionarUnicaPromocao = false">
                            <span>Fechar</span>
                        </button>

                        <button type="button" class="btn btn-outline-success float-right" @click="confirmarPromocaoSelecionado()">
                            <span>Confirmar</span>
                        </button>

                    </b-tab>

                </b-tabs>
            </div>

        </b-modal>

        <b-modal :no-close-on-backdrop="true" :hide-header-close="true" :no-close-on-esc="true" size="lg" centered v-model="dialogoRegulamentoPromocao" :hide-footer="true" title="Regulamento" @on-back="hideAll()">
            <promocaoaceite v-if="dialogoRegulamentoPromocao" :promocoesComTermo="promocoesComTermo" @on-saved="hideAll()" @on-back="hideAll()" />
        </b-modal>

        <div v-if="dialogTermo">
            <b-modal size="lg" :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogTermo" :hide-footer="true" title="Termo de uso">
                <form>
                    <div class="row">
                        <div class="form-group col-md-12">
                            <div class="col-xs-9">
                                <div style="border: 1px solid #e5e5e5; height: 300px; overflow: auto; padding: 10px;">
                                    <span v-html="termoUso.texto"></span>
                                </div>
                            </div>


                        </div>


                    </div>
                    <!--<p>
                        <input type="checkbox" value="aceito" @click="aceito = !aceito" required />&nbsp;
                        {{termoUso.textoAcordo}}
                    </p>
                    <button type="button" class="btn btn-success float-right" @click="confirmTermodeUso(termoUso)">
                        <span>Confirmar</span>
                    </button>-->
                    <div style="float:right;">
                        <button type="button" class="btn btn-outline-danger float-left" @click="dialogTermo = false">
                            <span>
                                pa
                                Fechar
                            </span>
                            pa
                        </button>
                    </div>



                </form>


            </b-modal>
        </div>


        <!-- termo de uso da koin -->
        <div v-if="dialogTermoUsoKoin">
            <b-modal size="xl" :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogTermoUsoKoin" :hide-footer="true" title="Termo de uso Koin">
                <form>
                    <div class="row">
                        <div class="form-group col-md-12">
                            <div style="border: 1px solid #e5e5e5; height: 80vh; overflow: auto;">
                                <iframe src="https://www.koin.com.br/termos-e-condicoes/" title="Termo de uso Koin" style="height: 100%; width:100% ;border: none" frameborder="0"></iframe>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button type="button" class="btn btn-outline-danger float-left" @click="dialogTermoUsoKoin = false">
                            <span>Fechar</span>
                        </button>
                        <button type="button" class="btn btn-outline-danger float-right" @click="onAceiteKoin">
                            <span>Aceitar e continuar</span>
                        </button>
                    </div>
                </form>
            </b-modal>
        </div>
        <!--fim termo de uso koin-->
        <!-- koin boleto parcelado -->
        <div v-if="dialogBoletoParceladoKoin">
            <b-modal size="lg" :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogBoletoParceladoKoin" :hide-footer="true" title="Boleto Parcelado Koin">
                <form>
                    <div class="row">
                        <div class="form-group col-md-12">
                            <div style="border: 1px solid #e5e5e5; height: 80vh; overflow: auto;">
                                <p>Boleto parcelado Koin...</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button type="button" class="btn btn-outline-danger float-left" @click="dialogBoletoParceladoKoin = false">
                            <span>Fechar</span>
                        </button>
                        <!--<button type="button" class="btn btn-outline-danger float-right" @click="onAceiteKoin">
                            <span>Aceitar e continuar</span>
                        </button>-->
                    </div>
                </form>
            </b-modal>
        </div>

        <div v-if="modalRespostaPix">
            <b-modal size="lg" scrollable :hide-header-close="true" :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="modalRespostaPix" :hide-footer="true" title="Dados para pagamento Pix!">
                <div class="text-modal-pix">
                    <div class="d-flex flex-column align-items-center">
                        <img :src="pedido ? pedido.pedidoPagamentoPix.imagemBase64 ? 'data:image/jpeg;base64,' + pedido.pedidoPagamentoPix.imagemBase64 : '' : ''" class="w-40" alt="qrCode" />
                        <strong>O código é válido até {{ pedido ? pedido.pedidoPagamentoPix ? pedido.pedidoPagamentoPix.dataDeValidade : '' : '' }}</strong>
                        <button type="button" class="btn btn-outline-success my-3" @click="onCopiarEColarPix">
                            <span>Copiar Código</span>
                        </button>
                    </div>
                    <div class="row">
                        <ol>
                            <li>Abra o app do banco de sua preferência e escolha a opção <strong>pagar com Pix</strong></li>
                            <li>Escolha a opção copiar código Pix ou escaneie o código QR Code</li>
                            <li>Confira as informações de pagamento e confirme a compra</li>
                        </ol>
                    </div>
                    <div class="row dados-recebedor-pix">
                        <div class="col-12 d-flex">
                            <div class="d-flex">
                                <img :src="getImagem('LOGOPIX')" alt="logo_pix" class="logo-pix-modal"/>
                            </div>
                            <span class="ml-3">
                                <span class="d-block"><strong>Dados do recebedor Pix:</strong></span>
                                Editora CNA Cultural Norte Americana S/A - CNPJ: 58.062.779/0001-50
                            </span>
                        </div>
                    </div>

                    <div class="row py-3">
                        <div class="col-12 d-flex ">
                            <div class="d-flex h-100">
                                <i class="fa fa-info-circle fa-2x"></i>
                            </div>
                            <span class="ml-3">Em caso de dúvida entre em contato com a sua escola ou com a nossa central de atendimento ao aluno: 4003-3599</span>
                        </div>
                    </div>
                </div>

                <div class="text-center">
                    <button type="button" class="btn btn-outline-secondary" @click="returnHome()" title="Retornar a Home">
                        <span>Voltar para a tela principal</span>
                    </button>
                    <router-link :to="{ name: 'imprimepedidopix', params: { filter: {pedidoId: pedido.pedidoId }}}" class="btn btn-outline-secondary">
                        <i class="fa fa-print"></i>
                    </router-link>
                </div>
            </b-modal>
        </div>
        <div v-if="modalRemoveProdutoCarrinho.show">
            <b-modal size="lg" scrollable :hide-header-close="true" :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="modalRemoveProdutoCarrinho.show" :hide-footer="true" title="Confirmação de Redução de Desconto Promocional">
                <div class="modal-body">
                    <div class="" style="display:flex; justify-content:space-evenly">
                        <div class="alert alert-info text-center w-100">
                            <p><span><b>Retirada do item {{ modalRemoveProdutoCarrinho.produtoItem.produto.nome }}</b></span></p>
                            <span>Desconto atual - {{ modalRemoveProdutoCarrinho.promocaoAtual.valorDesconto }}% ({{ modalRemoveProdutoCarrinho.promocaoAtual.nomePromocao }}) </span>
                        </div>
                        <img width="150px" src="../../../public/img/desconto.png" />
                    </div>
                    <div>
                        <div v-if="modalRemoveProdutoCarrinho.promocaoProxima" class="alert alert-warning text-center">
                            <span>Ao confirmar a retirada do item seu desconto será reduzido para {{ modalRemoveProdutoCarrinho.promocaoProxima.valorDesconto }}% - ({{ modalRemoveProdutoCarrinho.promocaoProxima.nome }})</span>
                        </div>
                        <div v-else class="alert alert-warning text-center">
                            <span>Ao confirmar a retirada do item seu desconto será reduzido para 0% (Nenhum Pack de desconto disponivel)</span>
                        </div>
                    </div>
                </div>
                <div class="modal-footer d-flex justify-content-between">
                    <button class="btn btn-raised btn-danger text-left" @click="modalRemoveProdutoCarrinho.show = false">Voltar</button>
                    <button class="btn btn-raised btn-info" @click="onRemoveProdutoCarrinho(modalRemoveProdutoCarrinho.produtoItem)">Continuar</button>
                </div>
            </b-modal>
        </div>

    </main>
</template>


<script>
    import Vue from 'vue'
    import base from '@/common/base.js'
    import { Api } from '@/common/api'
    import Global from '@/common/global'
    import Auth from '@/common/auth'
    import Vue2Filters from 'vue2-filters'
    import tutorStep from '@/common/tutor-step'
    import Cache from '@/common/cache'
    import moment from 'moment'

    Vue.use(Vue2Filters);

    import VISA from '../../assets/images/bandeirascartao/visa.png'
    import MASTERCARD from '../../assets/images/bandeirascartao/mastercard.png'
    import HIPERCARD from '../../assets/images/bandeirascartao/hipercard.png'
    import AMEX from '../../assets/images/bandeirascartao/amex.png'
    import DINERS from '../../assets/images/bandeirascartao/diners.png'
    import ELO from '../../assets/images/bandeirascartao/elo.png'
    import JCB from '../../assets/images/bandeirascartao/jcb.png'
    import DISCOVER from '../../assets/images/bandeirascartao/discover.png'
    import AURA from '../../assets/images/bandeirascartao/aura.png'
    import PADRAO from '../../assets/images/bandeirascartao/ico-cartao.png'
    import CARTAO from "../../assets/images/ico-cartao.png"
    import BOLETO from "../../assets/images/ico-boleto.png"
    import DEBIT from "../../assets/images/ico-cartao_debito.png"
    import CREDIT from "../../assets/images/ico-cartao_credito.png"
    import PIX from "../../assets/images/ico-pix.png"
    import promocaoaceite from "./promocaoaceite"
    import LOGOPIX from "../../assets/images/logo-pix.png"

    export default {
        name: "carrinho",
        mixins: [base, Vue2Filters.mixin],
        components: { promocaoaceite },
        data() {
            return {
                aceito: false,
                modalMessageErrorPromotion: false,
                modalMessageErrorCupom: false,
                messagemErrorCupom: "",
                exibeMessageErrorPagamento: true,
                dialogSelecionarUnicaPromocao: false,
                dialogConfirma: false,
                dialogReservaPedido: false,
                dialogConfirmaPagamento: false,
                dialogAlertaAtualizarDadosPagador: false,
                dialogDadosPagador: false,
                dialogConfirmaTermoAceite: false,
                dialogPromocaoDetalhe: false,
                dialogSelecionarPromocao: false,
                alertaPromocao: false,
                msgModalAlerta: "",
                //promoção aceite
                ehTravaCamposCompra: false,
                travaRegulamentoAoConcluir: false,
                idPromocaoControlaModal: 0,
                dialogoRegulamentoPromocao: false,
                promocaoId: 0,
                pessoaId: 0,
                textoRegulamento: "",
                pessoanome: "",
                ehZero: false,
                tipoProduto: "",
                temCashBack: false,
                ehCheckTransportadora: false,
                exibeMensagemValorZero: false,

                //exibeMensagemValorZero:false,

                //dialogCompraParcelamentoEscola: false,
                //menssagemParcelamentoEscola: "",

                //testePromocaosss: false,

                sessionId: "",

                dialogTermo: false,

                indexTabPromotion: 0,
                disabledTabPromocao: true,
                validarPromocao: null,

                aceitoReg: false,
                promocoesComTermo: [],

                dadosKoin: null,
                imagemCartao: PADRAO,
                imagemCartao2: PADRAO,
                cartaosecundario: false,

                totalKoin: 0,
                dialogTermoUsoKoin: false,
                dialogBoletoParceladoKoin: false,
                aceiteKoin: false,
                guidFraudId: null,
                valorParcelamentoKoin: null,
                paymentTypeKoin: null,
                escolaId: 0,
                installmentKoin: null,
                auxTipoProdutoId: 0,
                pedidoTemCashback: false,
                cashBackAnual: false,
                recusarCupomAutomatico: false,
                model: {
                    cupom: null,
                    formaPagamentoId: 0,
                    parcelamento: 0,
                    parcelamento2: 0,
                    gatewayId: null,
                    mes: "01",
                    ano: new Date().getFullYear(),
                    mes2: "01",
                    ano2: new Date().getFullYear(),
                    numeroCartao: "",
                    numeroCartao2: "",
                    cardFlag: "",
                    cardFlag2: "",
                    valorPriCartao: 0,
                    valorSegCartao: 0,
                    transportadoraId: 0,
                    ParcelaCNAStore: 0,
                    valorTotalLiquidoCNAStore: 0,
                    valorCampoAdicionalChave: "",
                    valorParcelamentoCupomTurbo: 0,
                    guidKoin: null,
                    paymentTypeKoin: null,
                    taxa: 0,

                    nomePagador: "",
                    emailPagador: "",
                    cpfpagador: "",
                    telefonePagador: "",
                    cepPagador: "",
                    ruaPagador: "",
                    numeroPagador: "",
                    complementoPagador: "",
                    bairroPagador: "",
                    cidadePagador: "",
                    estadoPagador: "",
                    dataNascimentoPagador: "",
                },

                gatewayEscolaFormaPagamentoResult: [],

                descontoGatewaySelecionado: { desconto: 0.00, },

                form: "form-pagamento",
                pedido: null,
                pessoaProduto: [],
                pessoaProdutoRemovido: [],
                promocoesPessoaProdutoSelecionado: {
                    collectionPromocaoPrevista: []
                },
                promocaoDetalhe: null,
                warningPromocao: [],
                resumoPedido: {
                    produtosForaPrazo: [],
                    collectionPessoaProduto: [],
                },
                ehCnaStore: false,
                ehTroca: false,
                transportadora: {},
                produtosIds: [],
                modalRespostaPix: false,
                dataDeValidadePix: null,
                dadosPreenchidos: false,
                modalRemoveProdutoCarrinho: {
                    show: false,
                    produtoItem: {},
                    promocaoAtual: {},
                    promocaoProxima: {}
                },
                itemRemoveProdutoCarrinho: {},
            }
        },
        methods: {
            getTermoUso: function () {
                this.dialogTermo = false;
                new Api("termouso/GetUltimoTermo").get({ attributeBehavior: "GetUltimoTermoUsoExibicao" }).then(data => {
                    setTimeout(() => {
                        if (data.data) {
                            this.termoUso = data.data;
                            this.dialogTermo = true;
                        } else {
                            this.dialogTermo = false
                        }
                    }, 1000);

                }, err => {
                    this.defaultErrorResult(err);
                })
            },
            changeDadosKoin() {
                this.dadosKoin = null;
                this.model.taxa = null;
                this.aceiteKoin = false;
                this.installmentKoin = null;
            },

            getTransportadora: function () {
                if (this.user.cep) {
                    new Api("transportadora/GetTransportadoraCEP").get({ cep: this.user.cep.replace("-", "") }).then(data => {
                        this.transportadora = data.dataList;
                        if (this.transportadora.length == 1)
                            this.model.transportadoraId = this.transportadora[0].transportadoraId;

                        if (this.transportadora.length <= 0) {
                            this.defaultErrorResult('Não foi localizada transportadora no range do CEP, ou o CEP se encontra com erro. Por favor, para finalizar o pedido entre em contato com a Administração Nacional.');
                            return;
                        }
                    }, err => {
                        this.defaultErrorResult(err);
                    })
                }
                else {
                    this.defaultErrorResult('A escola não apresenta um CEP cadastrado, ou o CEP se encontra com erro. Por favor, para finalizar o pedido entre em contato com a Administração Nacional.');
                    return;
                }

            },

            returnHome() {
                window.location = "/home"
            },

            //aceitoPromocao: function () {
            //    if (!this.aceito) {
            //        this.aceito = true;
            //        this.model.resumoPedido.EhAceitoPromocao = true;
            //    }
            //    else {
            //        this.aceito = false;
            //        this.model.resumoPedido.EhAceitoPromocao = false;
            //    }
            //},

            travaCamposCompra() {
                this.ehTravaCamposCompra = true;
            },

            onOpenSelecionarPromocoes(pessoaProduto) {
                this.modalMessageErrorPromotion = false;
                this.promocoesPessoaProdutoSelecionado = pessoaProduto;
                this.dialogSelecionarUnicaPromocao = true;
                this.exibeMessageErrorPagamento = true;
                this.disabledTabPromocao = false;
                this.indexTabPromotion = 0;
            },
            confirmarPromocaoSelecionado() {
                this.resumoPedido.collectionPessoaProduto.map(item => { return item.naoCarregarUnicaPromocao = true; })
                this.travaRegulamentoAoConcluir = false;

                this.calcularValorTotal(this.resumoPedido.collectionPessoaProduto);
                this.dialogSelecionarUnicaPromocao = false;

            },
            openPromocaoAceite: function () {
                this.dialogoRegulamentoPromocao = true;
            },

            hideAll: function () {
                this.dialogoRegulamentoPromocao = false;
            },

            nextSelectPromotion(pessoaProduto, index) {

                if (pessoaProduto[index].promocaoId == null && pessoaProduto[index].collectionPromocaoPrevista.length > 0) {
                    this.defaultErrorResult('Para prosseguir é necessário selecionar uma promoção para este produto.');
                    return;
                }
                this.indexTabPromotion += 1;
                this.calcularValorTotal(pessoaProduto);

                if (this.resumoPedido.collectionPessoaProduto.length == this.indexTabPromotion)
                    this.dialogSelecionarPromocao = false;

            },
            abrirDetalhesPromocao(promocao) {
                this.promocaoDetalhe = promocao;
                this.dialogPromocaoDetalhe = true;
            },
            getGatewayEscolaFormaPagamento() {

                this.showLoading();
                this.model.attributeBehavior = this.ehCnaStore ? "CarrinhoStore" : null;
                new Api("gatewayEscolaFormaPagamento/GetFormasPagamentoEscola").get({ escolaId: this.escolaId, PessoaProdutoIds: this.model.IdsProduto, attributeBehavior: this.model.attributeBehavior }).then(result => {
                    this.gatewayEscolaFormaPagamentoResult = result.dataList;
                    console.log(result.dataList)
                    this.hideLoading();

                    if (!this.dialogSelecionarPromocao)
                        this.startTutorial();
                })
            },
            removerCupom(PessoaProduto) {
                this.model.cupom = null;
                this.calcularValorTotal(PessoaProduto);
                this.model.parcelamentoPermitido = this.valorParcelamentoCupomTurbo;//essa ação esta ocorrendo por conta da task_17988
            },
            naoUsarCupomAutomatico(PessoaProduto) {
                this.recusarCupomAutomatico = true;
                this.model.cupom = null;
                this.calcularValorTotal(PessoaProduto);
            },
            validarCompra() {
                this.produtosIds = !this.ehCnaStore ? this.model.IdsProduto : null;
                if (this.model.IdsProduto.length > 0) {
                    new Api("pedido/GetValidacaoPedido").get({ ids: this.produtosIds }).then(result => {
                        if (result.data.valid)
                            this.getValidarPromocoes(this.model.IdsProduto);
                        else
                            this.defaultErrorResult("Não foi possível carregar seu carrinho", true);
                    }, err => {
                        this.defaultErrorResult(err, true);
                        setTimeout(() => { this.returnHome() }, 3000);
                    })
                }
            },
            getValidarPromocoes(pessoaProdutosIds) {
                this.produtosIds = !this.ehCnaStore ? this.model.IdsProduto : null;
                if (pessoaProdutosIds.length > 0) {
                    new Api("pedido/GetValidacaoPromocoes").get({ ids: this.produtosIds }).then(result => {
                        if (result.dataList && result.dataList.length > 0) {
                            this.validarPromocao = result.dataList;
                            this.alertaPromocao = true;
                        } else {
                            this.alertaPromocao = false;
                            this.prosseguirCompras();
                        }

                    }, err => {
                        this.defaultErrorResult(err, true);
                        setTimeout(() => { this.returnHome() }, 3000);
                    })
                }
            },
            prosseguirCompras() {
                this.getBrowserInfos();
                this.getProdutosFromUrl();
                this.alertaPromocao = false;
            },
            getProdutosFromUrl() {
                this.showLoading();
                // Define o AttributeBehavior com base se é CNA Store e se é troca
                if (this.ehCnaStore && this.ehTroca) {
                    this.model.attributeBehavior = "CarrinhoStoreTroca";
                } else if (this.ehCnaStore) {
                    this.model.attributeBehavior = "CarrinhoStore";
                } else {
                    this.model.attributeBehavior = null;
                }
                new Api("pessoaproduto").get({
                    pessoaProdutoIds: this.model.IdsProduto,
                    isPagination: "false",
                    attributeBehavior: this.model.attributeBehavior,
                    orderFields: "ordem"
                }).then(data => {
                    this.pessoaProduto = data.dataList;

                    if (this.pessoaProduto && this.pessoaProduto.length > 0) {
                        this.escolaId = this.pessoaProduto[0].escolaId;
                    }


                    this.hideLoading();
                    this.calcularValorTotal(this.pessoaProduto, true);
                }, err => {
                    this.defaultErrorResult(err);
                })
            },
            calcularValorTotal: function (pessoaProduto, carregaFormaPagamento) {
                this.promocoesComTermo = [];
                this.showLoading();
                //this.pessoaProduto.EhAceitoPromocao = this.aceito;
                this.exibeMensagemValorZero = false;
                new Api("pessoaproduto/CalcularValorTotalPedido").post({ PessoasProdutos: pessoaProduto, CodigoCupom: this.model.cupom, RecusarCupomAutomatico: this.recusarCupomAutomatico, GatewayEscolaFormaPagamento: this.descontoGatewaySelecionado, EhAceitoPromocao: this.aceito, parcelaCNAStore: this.model.parcelaCNAStore }).then(result => {

                    this.resumoPedido = result.data;
                    console.log("===============");
                    console.log(this.resumoPedido.valorTotalDesconto);
                    console.log("===============");
                /*    console.log(this.resumoPedido.loteCupom.ocultarCupom);*/

                    this.model.valorPriCartao = this.resumoPedido.valorTotalLiquido;
                    this.model.valorSegCartao = this.resumoPedido.valorTotalLiquido;
                    this.cartaosecundario = false;

                    this.auxTipoProdutoId = this.resumoPedido.auxTipoProdutoId;


                    this.tipoProduto = this.resumoPedido.tipoProduto;
                    this.temCashBack = this.resumoPedido.temCashBack;
                    this.model.valorTotalLiquidoCNAStore = this.resumoPedido.valorTotalLiquido;
                    //TASK_15410
                    if (this.resumoPedido.loteCupom != null) {
                        //Essa parte foi add para atender a task_17988 temporariamente
                        // Removido temporariamente para atenter a task 47594
                        //this.valorCampoAdicionalChave = this.resumoPedido.loteCupom.valorCampoAdicionalChave;
                        //if (this.valorCampoAdicionalChave != "") {
                        //    switch (this.valorCampoAdicionalChave) {
                        //        case 2:
                        //            this.model.parcelamentoPermitido = 6;
                        //            break;
                        //        case 3:
                        //            this.model.parcelamentoPermitido = 9;
                        //            break;
                        //        case 4:
                        //            this.model.parcelamentoPermitido = 12;
                        //            break;
                        //        default:
                        //        //this.model.parcelamentoPermitido = this.parcelamento;
                        //    }
                        //}
                        // Fim task 47594 temporariamente
                        //fim task_17988 temporariamente

                        if (this.resumoPedido.loteCupom.ehPercentual && this.resumoPedido.loteCupom.valorDesconto == 100)
                            this.exibeMensagemValorZero = true;
                    }
                    //Ajuste provisorio para atender o chamado https://app.shortcut.com/cna/story/69334/shopping-cna-parcelamento-em-18x
                    //Inicio

                    //if (this.model.formaPagamentoId == 2 && this.auxTipoProdutoId == 1) {
                    //   var maiorQuantidadesMdporAlunoIdioma = this.resumoPedido.quantidademaximaMDMesmoAlunoIdioma;
                    //    if (maiorQuantidadesMdporAlunoIdioma == 1) { this.model.parcelamentoPermitido = 6; }
                    //    else if (maiorQuantidadesMdporAlunoIdioma == 2) { this.model.parcelamentoPermitido = 12; }
                    //    else if (maiorQuantidadesMdporAlunoIdioma > 2) { this.model.parcelamentoPermitido = 18; }
                    //}
                     //Fim

                    //Ajuste para atender regras de parcelamento para determinados idiomas e estagios https://app.shortcut.com/cna/epic/71761/shopping-cna-ajuste-no-parcelamento-em-boleto?group_by=none&vc_group_by=day&ct_workflow=all&cf_workflow=500000039
                    //Comentado bloco acima e Inicio
                    if ((this.model.formaPagamentoId == 2 || this.model.formaPagamentoId == 6)  && this.auxTipoProdutoId == 1)
                        this.model.parcelamentoPermitido = this.resumoPedido.parcelamentoPermitido;
                    //Fim

                    for (var i = 0; i < this.resumoPedido.collectionPessoaProduto.length; i++) {
                        var pessoaProduto = this.resumoPedido.collectionPessoaProduto[i];

                        if (pessoaProduto.ehMatricula && pessoaProduto.escolaTemCashback && this.temCashBack && !this.pedidoTemCashback) {
                            this.pedidoTemCashback = true;
                        }
                        if (pessoaProduto.produtoCashbackAnual && !this.cashBackAnual) {
                            this.cashBackAnual = true;
                        }

                        if (pessoaProduto.messageErrorPromotion != null) {
                            this.indexTabPromotion = 0;
                            this.modalMessageErrorPromotion = true;
                            this.warningPromocao = pessoaProduto;
                            break;
                        }
                        if (this.resumoPedido.valorTotalLiquido <= 0 && !this.exibeMensagemValorZero) {//task-11412
                            this.modalMessageErrorPromotion = true;
                            this.warningPromocao.messageErrorPromotion = "Você deverá selecionar 2 ou mais livros  para seguir com o pedido da promoção. Volte a página inicial e selecione os demais livros";
                        }
                        //Criar aqui a chamada para a modal @PromocaoRegulamentoPessoa
                        if (pessoaProduto.promocaoId != null) {
                            for (var x = 0; x < pessoaProduto.collectionPromocaoPrevista.length; x++) {
                                if (pessoaProduto.promocaoId == pessoaProduto.collectionPromocaoPrevista[x].promocaoId) {
                                    var promocaoPrevista = pessoaProduto.collectionPromocaoPrevista[x];
                                    promocaoPrevista.nomeDestinatario = pessoaProduto.nomeDestinatario;
                                    promocaoPrevista.pessoaId = pessoaProduto.pessoaId;
                                    if (promocaoPrevista.ehObrigatoria)
                                        this.promocoesComTermo.push(promocaoPrevista)
                                }
                            }
                        }
                        
                        if (pessoaProduto.collectionPromocaoPrevista.length > 0 && pessoaProduto.promocaoId == null && pessoaProduto.naoCarregarUnicaPromocao == false)
                            this.dialogSelecionarPromocao = true;

                        if (this.promocoesComTermo.length > 0 && this.travaRegulamentoAoConcluir == false) {
                            this.openPromocaoAceite();
                        }

                    }

                    this.hideLoading();

                    if (carregaFormaPagamento)
                        this.getGatewayEscolaFormaPagamento();

                }, err => {
                    this.model.cupom = null;
                    this.indexTabPromotion = 0;
                    if (err.data.errors[0].indexOf("selecione apenas o material promocional") > 0) {
                        this.modalMessageErrorCupom = true;
                        this.messagemErrorCupom = err.data.errors[0].toString();

                        this.hideLoading();
                        return;
                    }
                    else {
                        this.defaultErrorResult(err, true);
                    }
                    //this.defaultErrorResult(err, true);
                    //if (err.data.errors[0].indexOf("Por favor compre separadamente") > 0) {
                    //    //setTimeout(() => { this.returnHome() }, 8000);

                    //}
                    //this.defaultErrorResult(err, true);
                    //setTimeout(() => { this.returnHome() }, 8000);
                })
            },
            formValidate: function () {
                var $form = this.$refs[this.form];
                return $form.checkValidity();
            },
            formatPrice(value) {
                return 'R$' + this.formatDecimal(value);
            },
            formatDecimal(value) {
                let val = (value / 1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
            confirmaAceite() {
                this.dialogConfirmaTermoAceite = false;
                this.dialogConfirma = true;
            },
            closeModalErrorCupom() {
                if (this.modalMessageErrorCupom) {
                    this.modalMessageErrorCupom = false;
                    window.location.href = "/home";
                }

            },
            confirmaReservaPedido() {

                this.setaReservaPedido(1, 1, 0);

                //this.dialogReservaPedido = true;
                this.concluirPedido();

            },
            geraFraudKoin() {
                GetKoinFraudID(guid => { this.guidFraudId = guid; });
            },
            retornaDataKoin(data) {
                var Data = data.split('-');

                return Data[2] + "/" + Data[1] + "/" + Data[0];
            },
            calcularTotalKoin() {
                if (this.installmentKoin) {
                    this.totalKoin = this.installmentKoin.orderValue;
                    this.paymentTypeKoin = this.installmentKoin.paymentType;
                    this.valorParcelamentoKoin = this.installmentKoin.installmentValue;

                    this.model.parcelamento = this.installmentKoin.installments;
                    this.model.taxa = this.totalKoin - this.resumoPedido.valorTotalLiquido;
                }
            },
            onAceiteKoin() {
                this.aceiteKoin = true;
                this.dialogTermoUsoKoin = false
            },
            confirmaTransacaoCompraKoin() {

                if (this.model.cpf == "" || typeof (this.model.cpf) == "undefined" || this.model.email == "" || typeof (this.model.email) == "undefined") {
                    this.defaultErrorResult("Informe o CPF e e-mail");
                    return;
                } else {
                    this.transactionKoin();
                }
            },
            transactionKoin() {
                this.dialogDadosPagador = false;
                this.dadosKoin = null;
                var dadosTransacao = {
                    cpf: this.model.cpf,
                    email: this.model.email,
                    totalPrice: this.resumoPedido.valorTotalLiquido,
                    gateWayId: this.model.gatewayId,
                    escolaId: this.escolaId,
                    quantidadeMds: this.resumoPedido.totalMDPedido
                };

                this.showLoading();
                new Api("payment/TransactionKoin", Global.END_POINT_PAYMENT).post(dadosTransacao).then(result => {
                    this.hideLoading();
                    console.log("=================Retorno Koin====================")
                    console.log(result.data);
                    let _data = result.data;
                    if (_data && _data.code == 12200) {
                        //console.log("=================Dado koin variavel====================")
                        this.dadosKoin = _data;
                        //console.log(this.dadosKoin);
                        //console.log("=================data koin variavel====================")

                        this.defaultSuccessResult("Transação concluída. Agora selecione a quantidade de parcelas!");
                        //console.log("=================geraFraudKoin====================")
                        this.geraFraudKoin();

                    }
                    else {
                        this.defaultErrorResult(_data ? _data.message : "Não foi possível completar sua requisição", true);
                    }
                }, err => {
                    this.defaultErrorResult(err);
                });
            },
            verificaCompradorLogado() {

                new Api("pessoa/Get").get({ CPF_CNPJ: this.model.cpf, attributeBehavior: "CheckCPfResponsavel" }).then(result => {
                    if (result.data) {
                        this.model.nomePagador = result.data.apelido;
                        this.model.telefonePagador = result.data.telefone;
                        this.model.cepPagador = this.user.cep;
                        this.model.ruaPagador = this.user.rua;
                        this.model.numeroPagador = this.user.numero;
                        this.model.complementoPagador = this.user.complemento;
                        this.model.bairroPagador = this.user.bairro;
                        this.model.cidadePagador = this.user.cidade;
                        this.model.estadoPagador = this.user.uf;
                        this.model.emailPagador = this.model.email;
                        this.model.cpfpagador = this.model.cpf;

                        if (result.data.apelido && result.data.telefone && this.user.cep && this.user.rua && this.user.numero &&
                            this.user.bairro && this.user.cidade && this.user.uf && this.model.email &&
                            this.model.cpf) {

                            this.confirmaTransacaoCompraKoin()
                        } else {
                            this.msgModalAlerta = "Identificamos que há dados incompletos em seu cadastro, clique no botão abaixo para atualizar seus dados antes de prosseguir com a compra.";
                            this.dialogAlertaAtualizarDadosPagador = true;
                        }
                        //realiza a chamada com os dados cadastrados
                    } else {
                        this.msgModalAlerta = "Identificamos que o cpf utilizado para realizar o pagamento não é o mesmo do cadastro, clique no botão abaixo para preencher seus dados antes de prosseguir com a compra.";
                        this.dialogAlertaAtualizarDadosPagador = true;
                        this.model.emailPagador = this.model.email;
                        this.model.cpfpagador = this.model.cpf;

                    }

                }, err => {
                    this.defaultErrorResult(err, true);
                    setTimeout(() => { this.returnHome() }, 3000);
                })
                //fim
            },
            proximocartao() {
                if (this.model.formaPagamentoId == 6 && this.cartaosecundario == false) {
                    if (this.model.valorPriCartao == this.resumoPedido.valorTotalLiquido) {
                        this.defaultErrorResult('O valor do primeiro cartão não pode ser integral.');
                    } else {
                        this.cartaosecundario = true;
                        this.model.valorSegCartao = this.model.valorSegCartao - this.model.valorPriCartao;
                    }
                }
            },
            confirmaCompra() {
                var verifyPromotion = [];

                for (var i = 0; i < this.resumoPedido.collectionPessoaProduto.length; i++) {
                    var item = this.resumoPedido.collectionPessoaProduto[i];
                    if (item.collectionPromocaoPrevista.length >= 1 && item.promocaoId == null && !this.resumoPedido.podeProseguir)
                        verifyPromotion.push(item);
                }

                if (verifyPromotion.length >= 1 && !this.aceito) {//task-11412
                    this.defaultErrorResult('Para finalizar a compra selecione uma promoção dentre as disponíveis para os itens a serem cobrados.');
                    return;
                }
                if (this.model.formaPagamentoId == 2 && this.formValidate() == false) {
                    this.defaultErrorResult('É necessário preencher todos os campos');
                    return;
                }
                if (this.model.formaPagamentoId == 6 && this.formValidate() == false) {
                    this.defaultErrorResult('É necessário preencher todos os campos');
                    return;
                }
                if (this.model.formaPagamentoId == 2 && this.model.parcelamento == 0) {
                    this.defaultErrorResult('É necessário selecionar o número de parcelas.');
                    return;
                }
                if (this.model.formaPagamentoId == 6 && this.model.parcelamento2 == 0) {
                    this.defaultErrorResult('É necessário selecionar o número de parcelas.');
                    return;
                }
                if (this.ehCnaStore) {
                    if (this.model.formaPagamentoId == 3 && this.model.parcelamento == 0) {
                        this.defaultErrorResult('É necessário selecionar o número de parcelas.');
                        return;
                    }
                    if (this.model.formaPagamentoId == 3 && (this.model.parcelamento == 6 && this.model.valorTotalLiquidoCNAStore < 600)) {
                        this.defaultErrorResult('É necessário selecionar o número de parcelas.');
                        return;
                    }
                    if (this.model.formaPagamentoId == 3 && this.model.transportadoraId == 0) {
                        this.defaultErrorResult('É necessário selecionar uma transportadora.');
                        return;
                    }
                }

                if (this.model.formaPagamentoId == 4 && this.formValidate() == false) {
                    this.defaultErrorResult('É necessário preencher todos os campos');
                    return;
                }
                if (this.model.formaPagamentoId == 5 && this.verificaDadosPagadorKoin()) {
                    return;
                }


                this.dialogConfirma = true;

            },
            segueCompraBoletoparceladoKoin() {
                if (this.verificaDadosPagadorKoin() == false) {
                    this.dialogAlertaAtualizarDadosPagador = false;
                    this.dadosPreenchidos = true;
                    this.confirmaTransacaoCompraKoin();
                }
            },
            verificaDadosPagadorKoin() {
                var campos = "";

                if (!this.model.nomePagador)
                    campos += "Nome, ";

                if (!this.model.emailPagador)
                    campos += "E-Mail, ";

                if (!this.model.cpfpagador)
                    campos += "CPF, ";

                if (!this.model.telefonePagador)
                    campos += "Telefone, ";

                if (!this.model.cepPagador)
                    campos += "CEP, ";

                if (!this.model.ruaPagador)
                    campos += "Rua, ";

                if (!this.model.numeroPagador)
                    campos += "Número, ";

                if (!this.model.bairroPagador)
                    campos += "Bairro, ";

                if (!this.model.cidadePagador)
                    campos += "Cidade, ";

                if (!this.model.estadoPagador)
                    campos += "Estado, ";

                if (!this.model.dataNascimentoPagador)
                    campos += "Data de nascimento, ";

                if (campos != "") {
                    this.defaultErrorResult('É necessário preencher todos os  seguintes campos: ' + campos.slice(0, -2));
                    return true;
                }

                return false;
            },
            concluirPedido() {
                this.dialogConfirma = false;
                this.showLoading();
                this.model.sessionId = this.sessionId;
                this.model.guidKoin = this.guidFraudId;
                this.model.paymentTypeKoin = this.paymentTypeKoin;
                this.model.CollectionPessoaProdutoSave = this.resumoPedido.collectionPessoaProduto;

                //aceita promoção
                this.model.EhAceitoPromocao = this.aceito;
                
                // Garante que EhTroca seja enviado corretamente ao backend
                this.model.EhTroca = this.ehTroca;

                //Chama bloqueio de botões task(7636)
                this.ehTravaCamposCompra = true;

                //console.log("Pagamento", this.model);
                if (this.ehCnaStore)
                    this.model.IdsProduto = localStorage.getItem("carrinho").split(",");
                
                // Limpa o localStorage de troca após concluir o pedido
                if (localStorage.getItem("carrinhoEhTroca")) {
                    localStorage.removeItem("carrinhoEhTroca");
                }

                // CWH-43471: garante que o codigo efetivo (auto-aplicado ou digitado) va ao pedido para o decremento do cupom.
                if (!this.model.cupom && this.resumoPedido && this.resumoPedido.loteCupom)
                    this.model.cupom = this.resumoPedido.loteCupom.codigoCupom;

                new Api("payment", Global.END_POINT_PAYMENT).post(this.model).then(data => {
                    this.ehTravaCamposCompra = false;

                    this.pedido = data.data;
                    this.dialogConfirmaPagamento = true;

                    var msgAdicional = "";
                    if (this.pedido &&
                        this.pedido.pedidoPagamento &&
                        this.pedido.pedidoPagamento.observacao)
                        msgAdicional = this.pedido.pedidoPagamento.observacao;

                    this.defaultSuccessResult("Pedido Gerado com Sucesso! " + msgAdicional);

                    if (this.pedido && this.model.formaPagamentoId == 7) {
                        //this.dataDeValidadePix = moment(new Date(this.pedido.pedidoPagamentoPix.dataDeValidade)).format('DD/MM/yyyy [às] H:mm:ss');
                        this.modalRespostaPix = true;
                    }

                    this.$emit('on-saved', data);
                    this.hideLoading();
                }, err => {
                    this.ehTravaCamposCompra = false;
                    this.defaultErrorResult(err, true);
                });
            },
            setaFormaPagamento(gatewaySelecionado, formaPagamentoId, gatewayId, parcelamento) {

                this.changeDadosKoin();

                //Popup boleto parcelado
                if (gatewaySelecionado == 5 && formaPagamentoId == 5)
                    this.dialogBoletoParceladoKoin = true;

                if (!gatewaySelecionado.desconto)
                    gatewaySelecionado.desconto = 0.00;

                //console.log("gatewaySelecionado", gatewaySelecionado);

                this.descontoGatewaySelecionado = gatewaySelecionado;
                this.model.gatewayId = gatewayId;
                this.model.formaPagamentoId = formaPagamentoId;
                this.model.parcelamentoPermitido = parcelamento;

                this.valorParcelamentoCupomTurbo = parcelamento;//ação para atender a task_17988

                this.model.parcelamento = formaPagamentoId == 1 || formaPagamentoId == 4 ? 1 : 0;
                this.travaRegulamentoAoConcluir = true;
                this.exibeMessageErrorPagamento = false;
                //alert("aceito" + this.aceito);
                this.model.EhAceitoPromocao = this.aceito;
                this.calcularValorTotal(this.resumoPedido.collectionPessoaProduto);
                this.limpaCampos();
            },
            setaReservaPedido(formaPagamentoId, gatewayId, parcelamento) {
                //if (!gatewaySelecionado.desconto)
                //    gatewaySelecionado.desconto = 0.00;

                this.descontoGatewaySelecionado = {
                    desconto: 0,
                    escolaId: 276,
                    formaPagamentoId: 1,
                    formaPagamentoNome: "Pedido Reservado",
                    gatewayId: 2,
                    parcelamento: 5
                };//gatewaySelecionado;
                this.model.gatewayId = gatewayId;
                this.model.formaPagamentoId = formaPagamentoId;
                this.model.parcelamentoPermitido = parcelamento;
                this.model.parcelamento = formaPagamentoId == 1 || formaPagamentoId == 4 ? 1 : 0;
                this.travaRegulamentoAoConcluir = true;
                this.exibeMessageErrorPagamento = false;
                //alert("aceito" + this.aceito);
                this.model.EhAceitoPromocao = this.aceito;
                //console.log("resumo do pedido ", this.resumoPedido.collectionPessoaProduto);
                this.calcularValorTotal(this.resumoPedido.collectionPessoaProduto);
            },
            setParcelamentoCNAStore(parcelamento) {
                //console.log("teste parcelamento store",parcelamento);
                this.model.parcelaCNAStore = parcelamento;
                this.model.EhCNAStore = true;
                //console.log("Enviado .....", this.resumoPedido.collectionPessoaProduto);
                this.calcularValorTotal(this.resumoPedido.collectionPessoaProduto);
            },
            getImagem(nomeImagem) {
                switch (nomeImagem) {
                    case "LOGOPIX":
                        return LOGOPIX;
                }
            },
            getImagemCartao(bandeira) {
                var imagem;
                switch (bandeira) {
                    case "visa":
                        imagem = VISA;
                        break;
                    case "mastercard":
                        imagem = MASTERCARD;
                        break;
                    case "amex":
                        imagem = AMEX;
                        break;
                    case "diners":
                        imagem = DINERS;
                        break;
                    case "elo":
                        imagem = ELO;
                        break;
                    case "hipercard":
                        imagem = HIPERCARD;
                        break;
                    case "jcb":
                        imagem = JCB;
                        break;
                    case "discover":
                        imagem = DISCOVER;
                        break;
                    case "hiper":
                        imagem = HIPERCARD;
                        break;
                    case "aura":
                        imagem = AURA;
                        break;
                    default:
                        imagem = PADRAO;
                        break;
                }
                if (this.cartaosecundario) {
                    this.imagemCartao2 = imagem;
                }
                else {
                    this.imagemCartao = imagem;
                }
            },
            getBrowserInfos() {
                this.$session.start()
                this.sessionId = this.$session.id();
                this.$session.destroy()
                this.model.userAgent = navigator.userAgent;
            },
            async getCardFlag(cardnumber) {
                if (!cardnumber) return;

                var cardnumber = cardnumber.replace(/[^0-9]+/g, '');
                var cards = {
                    //visa: /^4[0-9]{12}(?:[0-9]{3})/,
                    //elo: /^(636368|438935|504175|451416|636297)|((5067|4576|4011)\d{2})\d*$/,
                    visa: /^4\d{3}\d*$/,
                    elo: /^(636368|438935|504175|451416|636297|6504|5090)|((5067|4576|4011)\d{2})\d*$/,
                    mastercard: /^5[1-8]\d{14}$|^2(?:2(?:2[1-9]|[3-9]\d)|[3-6]\d\d|7(?:[01]\d|20))\d{12}$/,
                    diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
                    amex: /^3[47][0-9]{13}/,
                    discover: /^6(?:011|5[0-9]{2})[0-9]{12}/,
                    hipercard: /^(606282\d{10}(\d{3})?)|(3841\d{15})/,
                    hiper: /^6370\d{12}$/,
                    //elo: /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})/,
                    //elo: /^(636368|438935|504175|451416|636297)|((5067|4576|4011)\d{2})\d*$/,
                    jcb: /^(?:2131|1800|35\d{3})\d{11}/,
                    //aura: /^(5078\d{2})(\d{2})(\d{11})$/
                    aura: /^(50\d{4})\d{10}$/
                };
                var bandeiraEncontrada;
                for (var flag in cards) {
                    if (cards[flag].test(cardnumber)) {
                        if (this.cartaosecundario) {
                            this.model.cardFlag2 = flag;
                        } else {
                            this.model.cardFlag = flag;
                        }
                        bandeiraEncontrada = flag;
                        break;
                    }
                }

                this.showLoading();
                await new Api("CartaoExcecao/GetCartaoExcecaoBandeira").get({ NumeroCartao: cardnumber }).then(result => {
                    if (result.data) {
                        bandeiraEncontrada = result.data.bandeira.toLowerCase();
                    }
                    this.hideLoading();
                    return bandeiraEncontrada;
                }, err => {
                    this.hideLoading();
                    return false;
                })
                    .finally(() => { this.getImagemCartao(bandeiraEncontrada); });
            },
            goToPedido() {
                this.$router.push({ path: 'pedido', query: { id: this.pedido.pedidoId } });
            },
            imagemFormaPagamento(formaPagamentoId) {
                return formaPagamentoId == 2 || formaPagamentoId == 6 ? CREDIT : formaPagamentoId == 4 ? DEBIT : formaPagamentoId == 7 ? PIX : BOLETO;
            },
            startTutorial() {

                var steps = [
                    { element: ".table-carrinho", intro: "Vamos revisar seu carrinho, aqui estão os produtos que você irá realizar a compra" },
                    { element: ".btn-promocao", intro: "Caso tenha alguma promoção disponível, você pode selecionar ou trocar ela aqui neste botão" },
                    { element: ".row-cupom", intro: "Se existir algum cupom disponível, insira ele aqui" },
                    { element: ".formapagamento", intro: "Por fim é só escolher o gateway e forma de pagamento e conferir em quantas vezes você quer comprar os seus produtos" }
                ]

                tutorStep.startManual("TUTOR_CARRINHO", steps);
            },
            limpaCampos() {
                if (this.model.formaPagamentoId == 6) {
                    this.model.NomeImpressoCartao = "";
                    this.model.NomeImpressoCartao2 = "";
                    this.model.numeroCartao = "";
                    this.model.numeroCartao2 = "";
                    this.model.ano = new Date().getFullYear();
                    this.model.ano2 = new Date().getFullYear();
                    this.model.mes = "01";
                    this.model.CVV = "";
                    this.model.CVV2 = "";
                    this.model.mes2 = "01";
                    this.model.parcelamento = 0;
                    this.model.parcelamento2 = 0;
                    this.model.cardFlag = "";
                    this.model.cardFlag2 = "";
                    this.imagemCartao = PADRAO;
                    this.imagemCartao2 = PADRAO;
                }
            },
            onCopiarEColarPix() {
                if (this.pedido) {
                    if (this.pedido.pedidoPagamentoPix) {
                        navigator.clipboard.writeText(this.pedido.pedidoPagamentoPix.qrCopiaECola);
                        this.defaultSuccessResult('Copiado com sucesso!!!');
                    }
                }
            },
            onCopiarLinhaDigitavel() { 
                if (this.pedido && this.pedido.pedidoPagamento && this.pedido.pedidoPagamento.linhaDigitavel) { 
                    navigator.clipboard.writeText(this.pedido.pedidoPagamento.linhaDigitavel);
                    this.defaultSuccessResult('Copiado com sucesso!');
                }
            },

            onOpenModalRemoveProdutoCarrinho(item) {
                
                if (item.promocaoSelecionadoEhPack) {
                    this.modalRemoveProdutoCarrinho.produtoItem = item;
                    this.modalRemoveProdutoCarrinho.promocaoAtual = item.collectionPromocaoPrevista.find(p => p.promocaoId === item.promocaoId);

                    var novaCollectionPessoaProduto = this.resumoPedido.collectionPessoaProduto
                        .filter(p => p.pessoaProdutoId !== item.pessoaProdutoId)
                        .filter(p => p.nomeDestinatario == item.nomeDestinatario);

                    this.showLoading();
                    new Api("PessoaProduto/CalcularTrocaDePack").post(novaCollectionPessoaProduto).then(result => {
                        this.modalRemoveProdutoCarrinho.promocaoProxima = result.data;
                        this.modalRemoveProdutoCarrinho.show = true;
                        this.hideLoading();
                    }, err => {
                        this.defaultErrorResult(err);
                    });
                }
                else {
                    this.onRemoveProdutoCarrinho(item);
                }
            },
            onRemoveProdutoCarrinho(item) {

                this.resumoPedido.collectionPessoaProduto = this.resumoPedido.collectionPessoaProduto.filter(p => p.pessoaProdutoId !== item.pessoaProdutoId);
                this.pessoaProdutoRemovido.push(item);
                this.pessoaProdutoRemovido.sort((a, b) => a.ordem - b.ordem);

                this.resumoPedido.collectionPessoaProduto.forEach((item) => {
                    item.promocaoId = null;
                });

                this.calcularValorTotal(this.resumoPedido.collectionPessoaProduto);
                this.modalRemoveProdutoCarrinho.show = false

            },
            onReincluirProdutoCarrinho(item) {
                this.pessoaProdutoRemovido = this.pessoaProdutoRemovido.filter(p => p.pessoaProdutoId !== item.pessoaProdutoId);
                this.resumoPedido.collectionPessoaProduto.push(item);

                this.resumoPedido.collectionPessoaProduto.forEach((item) => {
                    item.promocaoId = null;
                });
                this.calcularValorTotal(this.resumoPedido.collectionPessoaProduto);
            }
        },
        computed: {
            cupomAutoAplicado() {
                return !!(this.resumoPedido && this.resumoPedido.loteCupom && this.resumoPedido.loteCupom.aplicadoAutomaticamente);
            },
            anosPermitidos() {
                let anos = [];
                let anoAtual = new Date().getFullYear();
                for (var i = anoAtual; i <= anoAtual + 15; i++)
                    anos.push({ text: i, value: i });
                return anos;
            },
            urlPessoaCNA() {
                return Global.URL_CNA_ACCOUNT +
                    "perfil/" +
                    this.user.pessoaCNAId;
            },
            maioresOrdemPorPessoa() {
                const map = {};
                
                this.resumoPedido.collectionPessoaProduto.forEach(item => {
                    const { nomeDestinatario, ordem } = item;
                    if (!map[nomeDestinatario] || ordem > map[nomeDestinatario]) {
                        map[nomeDestinatario] = ordem;
                    }
                });

                return map; 
            },
            menoresOrdemPorPessoa() {
                const map = {};

                this.pessoaProdutoRemovido.forEach(item => {
                    const { nomeDestinatario, ordem } = item;
                    if (!map[nomeDestinatario] || ordem < map[nomeDestinatario]) {
                        map[nomeDestinatario] = ordem;
                    }
                });

                return map;
            }
        },
        mounted() {

            this.ehCnaStore = Cache.get(Auth.ehCnaStore_key) == 'true' ? true : false;
            
            // Verifica se é uma compra de troca (CarrinhoStoreTroca)
            // Prioriza a query string da URL, que persiste após F5
            this.ehTroca = this.$route.query.ehTroca === "true" || this.$route.query.ehTroca === true;
            
            // Se não veio na URL, tenta o localStorage (retrocompatibilidade)
            if (!this.ehTroca && localStorage.getItem("carrinhoEhTroca") === "true") {
                this.ehTroca = true;
            }

            this.showLoading();
            var ids = this.$route.query.id;
            if (!Array.isArray(ids)) ids = Array(this.$route.query.id);
            this.model.IdsProduto = ids;

            this.validarCompra();

            window.scrollTo(0, 0);

            if (this.ehCnaStore) {
                this.getTransportadora();
                //this.trocandoCheckBox();
                this.model.formaPagamentoId = 3;
                this.model.gatewayId = 3;

                this.model.parcelamento = 6;
                this.model.parcelaCNAStore = 6;
            }
        },

    }
</script>
<style scoped="scss">
    /*tr:nth-child(odd) {
        background-color: #ffffff;
    }

    tr:nth-child(even) {
        background-color: #cccccc;
    }*/

    .logo-pix-modal {
        width: 2rem;
        height: 2rem;
    }

    .dados-recebedor-pix {
        border: 1px solid #64D8CD;
        padding: 1rem;
        border-radius: 5px 5px;
        margin-bottom: .5rem;
    }

    .text-modal-pix {
        font-size: 0.8rem
    }

    .list-group-item.active {
        background-color: #c24045;
        border-color: #c24045;
    }

    .selecionado {
        background-color: rgba(194, 64, 69, 1)
    }

    .bandeiracartao {
        width: 80px;
    }

    .text-small {
        font-size: 11px;
    }

    .total-desconto {
        color: blue;
    }

    .descricao-promocao {
        color: red;
    }

    .selectPromocao {
        background-color: #B81F25;
        color: white;
        width: 152px;
        margin-top: 20px;
    }

    .card-promocao {
        text-align: center;
        font-size: 20px;
        color: white;
    }

    /deep/ .modal-content {
        border-top-left-radius: 0.4rem;
        border-top-right-radius: 0.4rem;
    }


        /deep/ .modal-content .modal-header {
            background: #edadad !important;
        }


    .alert-warning {
        color: #856404;
        background-color: #fff3cd;
        border-color: #ffeeba;
    }

    .btn:disabled {
        pointer-events: none;
    }
</style>